


// import React, { useEffect, useState, useMemo } from "react";
// import {
//     BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
//     ResponsiveContainer, PieChart, Pie, Cell, LineChart, Line,
//     ComposedChart, Area, AreaChart, RadialBarChart, RadialBar
// } from "recharts";
// import {
//     TrendingUp, TrendingDown, DollarSign, ShoppingBag, Package,
//     Users, CreditCard, CheckCircle, Calculator,
//     Building, Tag, Truck, FileText, Utensils, Coffee, Pizza,
//     Cake, ShoppingCart, Calendar as CalendarIcon, Target,
//     BarChart as BarChartIcon, PieChart as PieChartIcon,
//     LineChart as LineChartIcon, AlertCircle, Shield,
//     Activity, Scale, Wallet, ChevronDown, X, Menu,
//     Download, Filter, Sparkles, Crown, Trophy, Zap, TrendingUp as TrendUp,
//     RotateCcw, Star, Clock, PackageOpen, UserCheck,
//     MessageSquare, ThumbsUp, Award, BarChart2, CreditCard as CreditCardIcon,
//     Star as StarIcon, BarChart3, PieChart as PieChartIcon2, LineChart as LineChartIcon2,
//     Percent, DollarSign as DollarSignIcon, CheckSquare
// } from 'lucide-react';
// import axios from "axios";
// import * as XLSX from 'xlsx';
// import "./StandardReport.css";

// import Revenue from "./Revenue";
// import Ratings from "./Ratings";
// import Financials from "./Financials";
// import Expenses from "./Expenses";
// import Orders from "./Orders";
// import Payments from "./Payments";

// const StandardReport = () => {
//     const [vendorId, setVendorId] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [data, setData] = useState(null);
//     const [timeRange, setTimeRange] = useState('monthly');
//     const [showMobileMenu, setShowMobileMenu] = useState(false);
//     const [activeView, setActiveView] = useState('revenue');
//     const [resetting, setResetting] = useState(false);
//     const [isMobile, setIsMobile] = useState(false);
//     const [timeFilter, setTimeFilter] = useState(null);
//     const [selectedYear, setSelectedYear] = useState(null);
//     const [selectedMonth, setSelectedMonth] = useState(null);
//     const [selectedWeek, setSelectedWeek] = useState(null);
//     const [customTotals, setCustomTotals] = useState(null);
//     const [loadingStats, setLoadingStats] = useState(false);



//     const [startDate, setStartDate] = useState(() => {
//         const date = new Date();
//         date.setDate(date.getDate() - 30);
//         return date.toISOString().split("T")[0]; // YYYY-MM-DD
//     });

//     const [endDate, setEndDate] = useState(() => {
//         return new Date().toISOString().split("T")[0]; // YYYY-MM-DD
//     });

//     const fetchData = async () => {
//         const vendorId = localStorage.getItem("vendorId");
//         const authToken = localStorage.getItem("authToken");

//         if (!vendorId || !authToken) {
//             alert("❌ Missing vendorId / token");
//             return;
//         }

//         setLoading(true);
//         setResetting(true);

//         try {
//             // 1. Get ALL-TIME totals (orders & revenue)
//             const allTimeRes = await axios.get(
//                 `https://backend.maamaas.com/food/api/orders/vendor/statistics/${vendorId}`,
//                 {
//                     headers: { Authorization: `Bearer ${authToken}` }
//                 }
//             );

//             const allTimeData = allTimeRes.data;

//             // 2. Get CUSTOM DATE RANGE rating
//             let customRating = 0;

//             // Only fetch custom rating if we have date range selected
//             if (startDate && endDate) {
//                 try {
//                     const customRes = await axios.get(
//                         `https://backend.maamaas.com/food/api/orders/vendor/statistics/custom` +
//                         `?vendorId=${vendorId}&fromDate=${startDate}&toDate=${endDate}`,
//                         {
//                             headers: { Authorization: `Bearer ${authToken}` }
//                         }
//                     );

//                     customRating = Number(customRes.data.averageRating) || 0;
//                 } catch (customErr) {
//                     console.warn("⚠️ Could not fetch custom rating, using all-time rating");
//                     customRating = Number(allTimeData.averageRating) || 0;
//                 }
//             } else {
//                 // Use all-time rating if no date range
//                 customRating = Number(allTimeData.averageRating) || 0;
//             }

//             // Combine the data
//             const mappedTotals = {
//                 revenue: allTimeData.totalRevenue ?? 0,           // From ALL-TIME API
//                 orders: allTimeData.totalOrders ?? 0,             // From ALL-TIME API
//                 avgRating: customRating,                          // From CUSTOM API (or all-time)
//             };


//             setCustomTotals(mappedTotals);

//             // If we have a date range selected, show "custom", otherwise show "all-time"
//             if (startDate && endDate) {
//                 setTimeRange("custom");
//             }

//         } catch (err) {
//             console.error("❌ Error fetching report:", err);
//             alert("❌ Error fetching data. Check console.");
//         } finally {
//             setLoading(false);
//             setResetting(false);
//         }
//     };





//     const fetchCustomRangeTotals = async (fromDate, toDate) => {
//         if (!vendorId || !fromDate || !toDate) return;

//         setLoadingStats(true);

//         try {
//             const token = localStorage.getItem("authToken");

//             // 1. Get all-time totals for orders and revenue
//             const allTimeRes = await fetch(
//                 `https://backend.maamaas.com/food/api/orders/vendor/statistics/${vendorId}`,
//                 {
//                     headers: { Authorization: `Bearer ${token}` },
//                 }
//             );
//             const allTimeData = await allTimeRes.json();

//             // 2. Get custom date range rating
//             const customRes = await fetch(
//                 `https://backend.maamaas.com/food/api/orders/vendor/statistics/custom?vendorId=${vendorId}&fromDate=${fromDate}&toDate=${toDate}`,
//                 {
//                     headers: { Authorization: `Bearer ${token}` },
//                 }
//             );
//             const customData = await customRes.json();

//             // Combine data
//             const mappedTotals = {
//                 revenue: allTimeData.totalRevenue || 0,            // From ALL-TIME API
//                 orders: allTimeData.totalOrders || 0,              // From ALL-TIME API
//                 avgRating: Number(customData.averageRating) || 0,  // From CUSTOM API
//             };

//             setCustomTotals(mappedTotals);
//             setTimeRange("custom");

//         } catch (err) {
//             console.error("❌ Custom range API error:", err);
//         } finally {
//             setLoadingStats(false);
//         }
//     };


//     // Enhanced color palette
//     const colors = {
//         primary: '#7c3aed', // Purple
//         secondary: '#10b981', // Emerald
//         accent: '#f59e0b', // Amber
//         danger: '#ef4444', // Red
//         info: '#3b82f6', // Blue
//         success: '#10b981', // Green
//         warning: '#f59e0b', // Yellow
//         dark: '#1f2937',
//         light: '#f9fafb',
//         gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//         gradient2: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
//         gradient3: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
//     };

//     // Date range state
//     const [showDatePicker, setShowDatePicker] = useState(false);


//     // Responsive check
//     useEffect(() => {
//         const checkMobile = () => setIsMobile(window.innerWidth < 768);
//         checkMobile();
//         window.addEventListener('resize', checkMobile);
//         return () => window.removeEventListener('resize', checkMobile);
//     }, []);

//     // Get vendor ID
//     useEffect(() => {
//         const storedVendorId = localStorage.getItem("vendorId");
//         if (storedVendorId) setVendorId(storedVendorId);
//     }, []);

//     // Fetch data


//     // Helper function to show time filter
//     const showTimeFilter = (filterType) => {
//         setTimeFilter(filterType);
//         setShowDatePicker(false);

//         // Set default selections
//         const today = new Date();
//         if (filterType === 'yearly') {
//             setSelectedYear(today.getFullYear().toString());
//         } else if (filterType === 'monthly') {
//             setSelectedMonth((today.getMonth() + 1).toString().padStart(2, '0'));
//         } else if (filterType === 'weekly') {
//             setSelectedWeek('This Week');
//         }
//     };

//     // Function to handle year selection
//     const selectYear = (year) => {
//         setSelectedYear(year);
//         setTimeFilter(null);

//         // Set date range for selected year
//         const startDate = `${year}-01-01`;
//         const endDate = `${year}-12-31`;
//         setStartDate(startDate);
//         setEndDate(endDate);
//         setTimeRange('custom');

//         // Fetch data for selected year
//         fetchDataForRange(startDate, endDate);
//     };

//     // Function to handle month selection
//     const selectMonth = (month) => {
//         setSelectedMonth(month);
//         setTimeFilter(null);

//         const today = new Date();
//         const year = today.getFullYear();
//         const startDate = `${year}-${month}-01`;

//         // Calculate last day of month
//         const lastDay = new Date(year, parseInt(month), 0).getDate();
//         const endDate = `${year}-${month}-${lastDay}`;

//         setStartDate(startDate);
//         setEndDate(endDate);
//         setTimeRange('custom');

//         // Fetch data for selected month
//         fetchDataForRange(startDate, endDate);
//     };

//     // Function to handle week selection
//     const selectWeek = (week) => {
//         setSelectedWeek(week);
//         setTimeFilter(null);

//         const today = new Date();
//         let startDate, endDate;

//         if (week === 'This Week') {
//             // Get current week's Monday to Sunday
//             const day = today.getDay();
//             const diff = today.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is Sunday
//             const monday = new Date(today.setDate(diff));
//             const sunday = new Date(monday);
//             sunday.setDate(monday.getDate() + 6);

//             startDate = monday.toISOString().split('T')[0];
//             endDate = sunday.toISOString().split('T')[0];
//         } else if (week === 'Last Week') {
//             // Get last week's Monday to Sunday
//             const lastWeek = new Date(today);
//             lastWeek.setDate(today.getDate() - 7);
//             const day = lastWeek.getDay();
//             const diff = lastWeek.getDate() - day + (day === 0 ? -6 : 1);
//             const monday = new Date(lastWeek.setDate(diff));
//             const sunday = new Date(monday);
//             sunday.setDate(monday.getDate() + 6);

//             startDate = monday.toISOString().split('T')[0];
//             endDate = sunday.toISOString().split('T')[0];
//         } else {
//             // For specific weeks, you can implement custom logic
//             // This is a simplified version
//             const weekNum = parseInt(week.split(' ')[1]);
//             const year = today.getFullYear();

//             // Simplified calculation - adjust based on your needs
//             const month = Math.ceil(weekNum / 4);
//             const weekInMonth = weekNum % 4 || 4;

//             // Calculate approximate dates
//             const startDay = (weekInMonth - 1) * 7 + 1;
//             const endDay = Math.min(weekInMonth * 7, 30);

//             startDate = `${year}-${month.toString().padStart(2, '0')}-${startDay.toString().padStart(2, '0')}`;
//             endDate = `${year}-${month.toString().padStart(2, '0')}-${endDay.toString().padStart(2, '0')}`;
//         }

//         setStartDate(startDate);
//         setEndDate(endDate);
//         setTimeRange('custom');

//         // Fetch data for selected week
//         fetchDataForRange(startDate, endDate);
//     };

//     // Function to fetch data for a specific date range
//     const fetchDataForRange = (start, end) => {
//         // Your existing fetch logic adapted for specific date range
//         // Call your API with start and end dates
//     };
//     // Add this useEffect to close filter when clicking outside
//     useEffect(() => {
//         const handleClickOutside = (event) => {
//             if (timeFilter && !event.target.closest('.time-filter-container')) {
//                 setTimeFilter(null);
//             }
//         };

//         document.addEventListener('mousedown', handleClickOutside);
//         return () => {
//             document.removeEventListener('mousedown', handleClickOutside);
//         };
//     }, [timeFilter]);
//     // Reset function
//     const handleReset = () => {
//         setResetting(true);
//         setTimeRange('monthly');
//         const defaultStartDate = new Date();
//         defaultStartDate.setDate(defaultStartDate.getDate() - 30);
//         setStartDate(defaultStartDate.toISOString().split('T')[0]);
//         setEndDate(new Date().toISOString().split('T')[0]);
//         setActiveView('revenue');
//         setShowDatePicker(false);
//         if (isMobile) setShowMobileMenu(false);
//         fetchData();
//         setTimeout(() => setResetting(false), 1000);
//     };

//     useEffect(() => {
//         fetchData();
//     }, [vendorId]);

//     // Handle date range change
//     const handleDateRangeApply = () => {
//         setShowDatePicker(false);
//         setTimeRange("custom");

//         fetchCustomRangeTotals(startDate, endDate);
//     };


//     const handleDateRangeCancel = () => {
//         setShowDatePicker(false);
//     };

//     // Calculate days difference
//     const getDaysDifference = (start, end) => {
//         const startDate = new Date(start);
//         const endDate = new Date(end);
//         const timeDiff = endDate.getTime() - startDate.getTime();
//         return Math.floor(timeDiff / (1000 * 3600 * 24)) + 1;
//     };

//     // Format date for display
//     const formatDate = (dateString) => {
//         const date = new Date(dateString);
//         return date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
//     };

//     // ========== DATA GENERATORS ==========

//     // Generate date-wise revenue trend data
//     const generateDateTrendData = useMemo(() => {
//         if (timeRange === 'custom') {
//             const daysDiff = getDaysDifference(startDate, endDate);
//             const data = [];
//             const start = new Date(startDate);

//             for (let i = 0; i < daysDiff; i++) {
//                 const currentDate = new Date(start);
//                 currentDate.setDate(start.getDate() + i);
//                 const revenue = 15000 + Math.random() * 10000;
//                 const discount = Math.random() > 0.8 ? revenue * 0.1 : 0;
//                 data.push({
//                     date: currentDate.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' }),
//                     fullDate: currentDate,
//                     revenue: Math.round(revenue),
//                     netRevenue: Math.round(revenue - discount),
//                     discount: Math.round(discount),
//                     orders: Math.round(50 + Math.random() * 30)
//                 });
//             }
//             return data;
//         }

//         const getDays = () => {
//             switch (timeRange) {
//                 case 'weekly': return 7;
//                 case 'monthly': return 30;
//                 case 'yearly': return 12;
//                 default: return 30;
//             }
//         };

//         const days = getDays();
//         const data = [];

//         for (let i = days - 1; i >= 0; i--) {
//             const date = new Date();

//             if (timeRange === 'weekly') {
//                 date.setDate(date.getDate() - (i * 7));
//                 const revenue = 100000 + Math.random() * 50000;
//                 const discount = revenue * (0.05 + Math.random() * 0.05);
//                 data.push({
//                     date: `Week ${i + 1}`,
//                     fullDate: new Date(date),
//                     revenue: Math.round(revenue),
//                     netRevenue: Math.round(revenue - discount),
//                     discount: Math.round(discount),
//                     orders: Math.round(200 + Math.random() * 100)
//                 });
//             } else if (timeRange === 'monthly') {
//                 const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
//                 const monthIndex = (11 - i) % 12;
//                 const revenue = 350000 + Math.random() * 150000;
//                 const discount = revenue * (0.08 + Math.random() * 0.07);
//                 data.push({
//                     date: months[monthIndex],
//                     fullDate: new Date(date.getFullYear(), monthIndex, 1),
//                     revenue: Math.round(revenue),
//                     netRevenue: Math.round(revenue - discount),
//                     discount: Math.round(discount),
//                     orders: Math.round(1000 + Math.random() * 500)
//                 });
//             } else { // yearly
//                 const years = ['2020', '2021', '2022', '2023', '2024'];
//                 if (i < years.length) {
//                     const revenue = 4000000 + Math.random() * 2000000;
//                     const discount = revenue * (0.1 + Math.random() * 0.05);
//                     data.push({
//                         date: years[i],
//                         fullDate: new Date(years[i]),
//                         revenue: Math.round(revenue),
//                         netRevenue: Math.round(revenue - discount),
//                         discount: Math.round(discount),
//                         orders: Math.round(12000 + Math.random() * 5000)
//                     });
//                 }
//             }
//         }
//         return data;
//     }, [timeRange, startDate, endDate]);

//     // Generate expense trend data
//     const generateExpenseTrendData = useMemo(() => {
//         const dateData = generateDateTrendData;
//         return dateData.map(item => {
//             const expenses = {
//                 COGS: Math.round(item.revenue * (0.35 + Math.random() * 0.05)),
//                 Operating: Math.round(item.revenue * (0.20 + Math.random() * 0.03)),
//                 Labor: Math.round(item.revenue * (0.18 + Math.random() * 0.02)),
//                 Equipment: Math.round(item.revenue * (0.08 + Math.random() * 0.02)),
//                 Marketing: Math.round(item.revenue * (0.06 + Math.random() * 0.01)),
//                 Packaging: Math.round(item.revenue * (0.04 + Math.random() * 0.01)),
//                 Delivery: Math.round(item.revenue * (0.12 + Math.random() * 0.03)),
//                 Waste: Math.round(item.revenue * (0.03 + Math.random() * 0.01)),
//                 Tax: Math.round(item.revenue * (0.05 + Math.random() * 0.01)),
//                 Miscellaneous: Math.round(item.revenue * (0.02 + Math.random() * 0.01))
//             };

//             const totalExpenses = Object.values(expenses).reduce((a, b) => a + b, 0);
//             const profit = item.netRevenue - totalExpenses;
//             const profitMargin = (profit / item.revenue) * 100;
//             const expenseRatio = (totalExpenses / item.revenue) * 100;

//             return {
//                 date: item.date,
//                 fullDate: item.fullDate,
//                 revenue: item.revenue,
//                 netRevenue: item.netRevenue,
//                 totalExpenses,
//                 profit,
//                 profitMargin: parseFloat(profitMargin.toFixed(1)),
//                 expenseRatio: parseFloat(expenseRatio.toFixed(1)),
//                 ...expenses
//             };
//         });
//     }, [generateDateTrendData]);

//     // Calculate totals for each time range
//     const calculateTimeRangeTotals = useMemo(() => {
//         const ranges = ['yearly', 'monthly', 'weekly', 'custom'];
//         const totals = {};

//         ranges.forEach(range => {
//             let data;
//             if (range === 'custom') {
//                 const daysDiff = getDaysDifference(startDate, endDate);
//                 const tempData = [];
//                 const start = new Date(startDate);

//                 for (let i = 0; i < daysDiff; i++) {
//                     const currentDate = new Date(start);
//                     currentDate.setDate(start.getDate() + i);
//                     const revenue = 15000 + Math.random() * 10000;
//                     const discount = Math.random() > 0.8 ? revenue * 0.1 : 0;
//                     tempData.push({
//                         revenue: Math.round(revenue),
//                         netRevenue: Math.round(revenue - discount),
//                         discount: Math.round(discount),
//                         orders: Math.round(50 + Math.random() * 30)
//                     });
//                 }
//                 data = tempData;
//             } else {
//                 const getDays = () => {
//                     switch (range) {
//                         case 'weekly': return 7;
//                         case 'monthly': return 30;
//                         case 'yearly': return 12;
//                         default: return 30;
//                     }
//                 };

//                 const days = getDays();
//                 const tempData = [];

//                 for (let i = days - 1; i >= 0; i--) {
//                     if (range === 'weekly') {
//                         const revenue = 100000 + Math.random() * 50000;
//                         const discount = revenue * (0.05 + Math.random() * 0.05);
//                         tempData.push({
//                             revenue: Math.round(revenue),
//                             netRevenue: Math.round(revenue - discount),
//                             discount: Math.round(discount),
//                             orders: Math.round(200 + Math.random() * 100)
//                         });
//                     } else if (range === 'monthly') {
//                         const revenue = 350000 + Math.random() * 150000;
//                         const discount = revenue * (0.08 + Math.random() * 0.07);
//                         tempData.push({
//                             revenue: Math.round(revenue),
//                             netRevenue: Math.round(revenue - discount),
//                             discount: Math.round(discount),
//                             orders: Math.round(1000 + Math.random() * 500)
//                         });
//                     } else { // yearly
//                         const revenue = 4000000 + Math.random() * 2000000;
//                         const discount = revenue * (0.1 + Math.random() * 0.05);
//                         tempData.push({
//                             revenue: Math.round(revenue),
//                             netRevenue: Math.round(revenue - discount),
//                             discount: Math.round(discount),
//                             orders: Math.round(12000 + Math.random() * 5000)
//                         });
//                     }
//                 }
//                 data = tempData;
//             }

//             // Calculate totals for this range
//             const totalRevenue = data.reduce((sum, item) => sum + item.revenue, 0);
//             const totalNetRevenue = data.reduce((sum, item) => sum + item.netRevenue, 0);
//             const totalOrders = data.reduce((sum, item) => sum + item.orders, 0);

//             // Calculate expenses
//             const totalExpenses = Math.round(totalRevenue * 0.65); // Simplified expense calculation

//             // For ratings (average based on orders)
//             const totalReviews = Math.round(totalOrders * 0.3);
//             const avgRating = 4.2 + Math.random() * 0.8;

//             totals[range] = {
//                 revenue: totalRevenue,
//                 netRevenue: totalNetRevenue,
//                 expenses: totalExpenses,
//                 orders: totalOrders,
//                 profit: totalNetRevenue - totalExpenses,
//                 avgRating: parseFloat(avgRating.toFixed(1)),
//                 totalReviews: totalReviews
//             };
//         });

//         return totals;
//     }, [timeRange, startDate, endDate]);

//     // Generate revenue by order type
//     const generateOrderTypeData = useMemo(() => {
//         const types = [
//             { name: 'Dine-in', description: 'In-restaurant dining', color: '#7c3aed', icon: <Utensils size={16} /> },
//             { name: 'Takeaway', description: 'Pickup orders', color: '#10b981', icon: <ShoppingBag size={16} /> },
//             { name: 'Delivery', description: 'Home delivery', color: '#3b82f6', icon: <ShoppingCart size={16} /> },
//             { name: 'Table', description: 'Event catering', color: '#f59e0b', icon: <Users size={16} /> }
//         ];

//         const totalRevenue = generateDateTrendData.reduce((sum, item) => sum + item.revenue, 0);
//         return types.map(type => {
//             const percentage = type.name === 'Delivery' ? 40 :
//                 type.name === 'Dine-in' ? 30 :
//                     type.name === 'Takeaway' ? 15 : 5;
//             const revenue = Math.round(totalRevenue * (percentage / 100));

//             return {
//                 ...type,
//                 revenue,
//                 percentage,
//                 growth: (Math.random() > 0.5 ? 1 : -1) * (2 + Math.random() * 6)
//             };
//         });
//     }, [generateDateTrendData]);

//     // Generate revenue by category
//     const generateCategoryData = useMemo(() => {
//         const categories = [
//             { name: 'Starters', description: 'Appetizers & snacks', color: '#f59e0b', icon: <Pizza size={16} /> },
//             { name: 'Main Course', description: 'Main dishes & curries', color: '#10b981', icon: <Utensils size={16} /> },
//             { name: 'Biryani', description: 'Rice dishes', color: '#ef4444', icon: <Pizza size={16} /> },
//             { name: 'Fast Food', description: 'Burgers, pizzas, etc.', color: '#8b5cf6', icon: <ShoppingBag size={16} /> },
//             { name: 'Desserts', description: 'Sweets & desserts', color: '#ec4899', icon: <Cake size={16} /> },
//             { name: 'Beverages', description: 'Drinks & beverages', color: '#3b82f6', icon: <Coffee size={16} /> }
//         ];

//         const totalRevenue = generateDateTrendData.reduce((sum, item) => sum + item.revenue, 0);
//         return categories.map(category => {
//             const percentage = category.name === 'Main Course' ? 35 :
//                 category.name === 'Biryani' ? 25 :
//                     category.name === 'Starters' ? 15 :
//                         category.name === 'Fast Food' ? 10 :
//                             category.name === 'Beverages' ? 8 : 7;
//             const revenue = Math.round(totalRevenue * (percentage / 100));

//             return {
//                 ...category,
//                 revenue,
//                 percentage,
//                 growth: (Math.random() > 0.5 ? 1 : -1) * (3 + Math.random() * 8)
//             };
//         }).sort((a, b) => b.revenue - a.revenue);
//     }, [generateDateTrendData]);

//     // Generate top selling items
//     const generateTopItemsData = useMemo(() => {
//         const items = [
//             { name: 'Chicken Biryani', category: 'Biryani', price: 320, cost: 180 },
//             { name: 'Paneer Butter Masala', category: 'Main Course', price: 280, cost: 120 },
//             { name: 'Veg Spring Rolls', category: 'Starters', price: 180, cost: 80 },
//             { name: 'Chocolate Pastry', category: 'Desserts', price: 120, cost: 40 },
//             { name: 'Cold Coffee', category: 'Beverages', price: 100, cost: 30 },
//             { name: 'Veg Pizza', category: 'Fast Food', price: 200, cost: 100 },
//             { name: 'Chicken Curry', category: 'Main Course', price: 300, cost: 140 },
//             { name: 'Gulab Jamun', category: 'Desserts', price: 80, cost: 20 },
//             { name: 'Mango Shake', category: 'Beverages', price: 110, cost: 35 },
//             { name: 'French Fries', category: 'Fast Food', price: 130, cost: 50 }
//         ];

//         const totalRevenue = generateDateTrendData.reduce((sum, item) => sum + item.revenue, 0);
//         return items.map(item => {
//             const percentage = 2 + Math.random() * 6;
//             const revenue = Math.round(totalRevenue * (percentage / 100));
//             const orders = Math.round(revenue / item.price);
//             const profit = revenue - (orders * item.cost);
//             const profitMargin = (profit / revenue) * 100;

//             return {
//                 ...item,
//                 revenue,
//                 orders,
//                 profit,
//                 profitMargin: parseFloat(profitMargin.toFixed(1)),
//                 percentage: parseFloat(percentage.toFixed(1))
//             };
//         }).sort((a, b) => b.revenue - a.revenue);
//     }, [generateDateTrendData]);

//     // Generate payment data
//     const generatePaymentData = useMemo(() => {
//         const methods = [
//             { name: 'Cash', description: 'Cash payments', color: '#10b981', icon: <DollarSign size={16} /> },
//             { name: 'UPI', description: 'Digital payments', color: '#7c3aed', icon: <CreditCard size={16} /> },
//             { name: 'Card', description: 'Credit/Debit cards', color: '#3b82f6', icon: <CreditCard size={16} /> },
//             { name: 'Wallet', description: 'E-wallets', color: '#f59e0b', icon: <CreditCard size={16} /> },
//             { name: 'Credit', description: 'Credit accounts', color: '#ef4444', icon: <CreditCard size={16} /> }
//         ];

//         const totalRevenue = generateDateTrendData.reduce((sum, item) => sum + item.revenue, 0);
//         return methods.map(method => {
//             const percentage = method.name === 'UPI' ? 45 :
//                 method.name === 'Cash' ? 25 :
//                     method.name === 'Card' ? 15 :
//                         method.name === 'Wallet' ? 10 : 5;
//             const amount = Math.round(totalRevenue * (percentage / 100));

//             return {
//                 ...method,
//                 amount,
//                 percentage,
//                 transactions: Math.round(amount / (method.name === 'Cash' ? 500 : 800))
//             };
//         });
//     }, [generateDateTrendData]);

//     // Generate gross vs net revenue data
//     const generateGrossNetData = useMemo(() => {
//         return generateDateTrendData.map(item => ({
//             date: item.date,
//             gross: item.revenue,
//             net: item.netRevenue,
//             discount: item.discount,
//             discountRate: parseFloat(((item.discount / item.revenue) * 100).toFixed(1))
//         }));
//     }, [generateDateTrendData]);

//     // Generate discount impact data
//     const generateDiscountImpactData = useMemo(() => {
//         return generateDateTrendData.map((item, index) => ({
//             date: item.date,
//             ordersWithoutDiscount: Math.round(item.orders * 0.8),
//             ordersWithDiscount: item.orders,
//             discountOrders: Math.round(item.orders * 0.2),
//             revenueWithoutDiscount: Math.round(item.revenue * 1.1),
//             actualRevenue: item.revenue,
//             discountAmount: item.discount,
//             uplift: 25 + Math.random() * 15
//         }));
//     }, [generateDateTrendData]);

//     // Generate expense data
//     const generateExpenseData = useMemo(() => {
//         const totalRevenue = generateDateTrendData.reduce((sum, item) => sum + item.revenue, 0);

//         const expenses = [
//             {
//                 category: 'COGS',
//                 description: 'Cost of Goods Sold',
//                 details: 'Ingredients cost consumed',
//                 purpose: 'Controls food margin',
//                 color: '#ef4444',
//                 icon: <Calculator size={16} />,
//                 percentage: 35,
//                 amount: Math.round(totalRevenue * 0.35)
//             },
//             {
//                 category: 'Operating Expenses',
//                 description: 'Fixed operational costs',
//                 details: 'Rent, Electricity, Gas, Salaries, Licenses',
//                 purpose: 'Tracks unavoidable costs',
//                 color: '#f59e0b',
//                 icon: <Building size={16} />,
//                 percentage: 20,
//                 amount: Math.round(totalRevenue * 0.20)
//             },
//             {
//                 category: 'Labor Cost',
//                 description: 'Staff salaries & benefits',
//                 details: 'Payroll, overtime, incentives',
//                 purpose: 'Improves workforce planning',
//                 color: '#3b82f6',
//                 icon: <Users size={16} />,
//                 percentage: 18,
//                 amount: Math.round(totalRevenue * 0.18)
//             },
//             {
//                 category: 'Equipment Cost',
//                 description: 'Kitchen & maintenance',
//                 details: 'AMC, repairs, purchase',
//                 purpose: 'Maintenance efficiency',
//                 color: '#8b5cf6',
//                 icon: <Package size={16} />,
//                 percentage: 8,
//                 amount: Math.round(totalRevenue * 0.08)
//             },
//             {
//                 category: 'Marketing Expense',
//                 description: 'Promotions & advertising',
//                 details: 'Ads, offers, branding',
//                 purpose: 'Return on marketing investment',
//                 color: '#ec4899',
//                 icon: <Tag size={16} />,
//                 percentage: 6,
//                 amount: Math.round(totalRevenue * 0.06)
//             },
//             {
//                 category: 'Packaging Cost',
//                 description: 'Delivery materials',
//                 details: 'Delivery packaging & takeaway material',
//                 purpose: 'Impacts order profitability',
//                 color: '#10b981',
//                 icon: <ShoppingBag size={16} />,
//                 percentage: 4,
//                 amount: Math.round(totalRevenue * 0.04)
//             },
//             {
//                 category: 'Delivery Commission',
//                 description: 'Platform fees',
//                 details: 'Swiggy / Zomato / logistics fee',
//                 purpose: 'Influences pricing decisions',
//                 color: '#6366f1',
//                 icon: <Truck size={16} />,
//                 percentage: 12,
//                 amount: Math.round(totalRevenue * 0.12)
//             },
//             {
//                 category: 'Waste & Expiry',
//                 description: 'Inventory losses',
//                 details: 'Raw material wasted or expired',
//                 purpose: 'Identify negligence / control inventory',
//                 color: '#f97316',
//                 icon: <AlertCircle size={16} />,
//                 percentage: 3,
//                 amount: Math.round(totalRevenue * 0.03)
//             },
//             {
//                 category: 'Tax & Compliance',
//                 description: 'Government fees',
//                 details: 'GST filing, government fees',
//                 purpose: 'Financial discipline',
//                 color: '#14b8a6',
//                 icon: <FileText size={16} />,
//                 percentage: 5,
//                 amount: Math.round(totalRevenue * 0.05)
//             },
//             {
//                 category: 'Miscellaneous',
//                 description: 'Other expenses',
//                 details: 'Extra cost entries',
//                 purpose: 'Track unknown leakage',
//                 color: '#8b5cf6',
//                 icon: <Shield size={16} />,
//                 percentage: 2,
//                 amount: Math.round(totalRevenue * 0.02)
//             }
//         ];

//         const totalExpenses = expenses.reduce((sum, expense) => sum + expense.amount, 0);
//         const netProfit = totalRevenue - totalExpenses;
//         const profitMargin = (netProfit / totalRevenue) * 100;

//         return {
//             expenses,
//             summary: {
//                 totalRevenue,
//                 totalExpenses,
//                 netProfit,
//                 profitMargin: parseFloat(profitMargin.toFixed(1)),
//                 expenseToRevenue: parseFloat(((totalExpenses / totalRevenue) * 100).toFixed(1))
//             }
//         };
//     }, [generateDateTrendData]);

//     // ========== NEW DATA GENERATORS FOR ORDERS, PAYMENTS, RATINGS ==========

//     // Generate orders analysis data
//     const generateOrdersData = useMemo(() => {
//         const dateData = generateDateTrendData;
//         const totalOrders = dateData.reduce((sum, item) => sum + item.orders, 0);

//         return {
//             trend: dateData.map(item => ({
//                 date: item.date,
//                 orders: item.orders,
//                 avgOrderValue: Math.round(item.revenue / item.orders),
//                 peakHours: {
//                     lunch: Math.round(item.orders * 0.4),
//                     dinner: Math.round(item.orders * 0.5),
//                     others: Math.round(item.orders * 0.1)
//                 }
//             })),
//             summary: {
//                 totalOrders,
//                 avgDailyOrders: Math.round(totalOrders / dateData.length),
//                 peakDay: dateData.reduce((prev, current) =>
//                     prev.orders > current.orders ? prev : current
//                 ),
//                 avgOrderValue: Math.round(
//                     dateData.reduce((sum, item) => sum + item.revenue, 0) /
//                     dateData.reduce((sum, item) => sum + item.orders, 0)
//                 )
//             },
//             byTimeSlot: [
//                 { time: '11AM-1PM', label: 'Dine-in', orders: Math.round(totalOrders * 0.35), color: '#f59e0b' },
//                 { time: '1PM-4PM', label: 'Takeaway', orders: Math.round(totalOrders * 0.15), color: '#3b82f6' },
//                 { time: '4PM-7PM', label: 'Delivery', orders: Math.round(totalOrders * 0.20), color: '#8b5cf6' },
//                 { time: '7PM-10PM', label: 'Table', orders: Math.round(totalOrders * 0.30), color: '#ef4444' }
//             ],
//             byDay: [
//                 { day: 'Monday', orders: Math.round(totalOrders * 0.14), growth: 5.2 },
//                 { day: 'Tuesday', orders: Math.round(totalOrders * 0.15), growth: 7.8 },
//                 { day: 'Wednesday', orders: Math.round(totalOrders * 0.16), growth: 3.4 },
//                 { day: 'Thursday', orders: Math.round(totalOrders * 0.17), growth: 9.1 },
//                 { day: 'Friday', orders: Math.round(totalOrders * 0.19), growth: 12.5 },
//                 { day: 'Saturday', orders: Math.round(totalOrders * 0.13), growth: -2.3 },
//                 { day: 'Sunday', orders: Math.round(totalOrders * 0.06), growth: -15.7 }
//             ],
//             orderStatus: [
//                 { status: 'Completed', count: Math.round(totalOrders * 0.85), color: '#10b981' },
//                 { status: 'Pending', count: Math.round(totalOrders * 0.08), color: '#f59e0b' },
//                 { status: 'Cancelled', count: Math.round(totalOrders * 0.05), color: '#ef4444' },
//                 { status: 'Refunded', count: Math.round(totalOrders * 0.02), color: '#64748b' }
//             ]
//         };
//     }, [generateDateTrendData]);

//     // Generate detailed payment mode data
//     const generatePaymentModeData = useMemo(() => {
//         const dateData = generateDateTrendData;
//         const totalRevenue = dateData.reduce((sum, item) => sum + item.revenue, 0);

//         const methods = [
//             { name: 'UPI', description: 'Digital payments', color: '#7c3aed', icon: <CreditCardIcon size={16} />, fee: 1.2 },
//             { name: 'Cash', description: 'Cash payments', color: '#10b981', icon: <DollarSignIcon size={16} />, fee: 0 },
//             { name: 'Card', description: 'Credit/Debit cards', color: '#3b82f6', icon: <CreditCard size={16} />, fee: 1.8 },
//             { name: 'Wallet', description: 'E-wallets', color: '#f59e0b', icon: <Wallet size={16} />, fee: 1.0 },
//             { name: 'Credit', description: 'Credit accounts', color: '#ef4444', icon: <CreditCard size={16} />, fee: 0 }
//         ];

//         return {
//             trend: dateData.map(item => {
//                 const methodsData = {};
//                 methods.forEach(method => {
//                     const percentage = method.name === 'UPI' ? 45 :
//                         method.name === 'Cash' ? 25 :
//                             method.name === 'Card' ? 15 :
//                                 method.name === 'Wallet' ? 10 : 5;
//                     methodsData[method.name] = Math.round(item.revenue * (percentage / 100));
//                 });
//                 return {
//                     date: item.date,
//                     ...methodsData
//                 };
//             }),
//             summary: methods.map(method => {
//                 const percentage = method.name === 'UPI' ? 45 :
//                     method.name === 'Cash' ? 25 :
//                         method.name === 'Card' ? 15 :
//                             method.name === 'Wallet' ? 10 : 5;
//                 const amount = Math.round(totalRevenue * (percentage / 100));
//                 const transactions = Math.round(amount / (method.name === 'Cash' ? 500 : 800));
//                 const processingFee = Math.round(amount * (method.fee / 100));

//                 return {
//                     ...method,
//                     amount,
//                     percentage,
//                     transactions,
//                     processingFee,
//                     netAmount: amount - processingFee
//                 };
//             }),
//             feeAnalysis: {
//                 totalFees: Math.round(totalRevenue * 0.012),
//                 avgFeePercentage: 1.2,
//                 mostCostly: 'Card',
//                 cheapest: 'Cash'
//             }
//         };
//     }, [generateDateTrendData]);

//     // Generate ratings and feedback data
//     const generateRatingsData = useMemo(() => {
//         const dateData = generateDateTrendData;
//         const totalOrders = dateData.reduce((sum, item) => sum + item.orders, 0);

//         return {
//             trend: dateData.map(item => ({
//                 date: item.date,
//                 avgRating: 4.2 + Math.random() * 0.8,
//                 totalReviews: Math.round(item.orders * 0.3),
//                 positiveReviews: Math.round(item.orders * 0.25),
//                 negativeReviews: Math.round(item.orders * 0.05)
//             })),
//             summary: {
//                 overallRating: 4.5,
//                 totalReviews: Math.round(totalOrders * 0.3),
//                 responseRate: 85,
//                 avgResponseTime: '2.4 hours'
//             },
//             distribution: [
//                 { rating: 5, count: Math.round(totalOrders * 0.15), color: '#10b981', label: 'Excellent' },
//                 { rating: 4, count: Math.round(totalOrders * 0.10), color: '#3b82f6', label: 'Good' },
//                 { rating: 3, count: Math.round(totalOrders * 0.03), color: '#f59e0b', label: 'Average' },
//                 { rating: 2, count: Math.round(totalOrders * 0.01), color: '#ef4444', label: 'Poor' },
//                 { rating: 1, count: Math.round(totalOrders * 0.01), color: '#dc2626', label: 'Terrible' }
//             ],
//             feedbackCategories: [
//                 { category: 'Food Quality', rating: 4.7, reviews: 125, color: '#10b981' },
//                 { category: 'Delivery Time', rating: 4.2, reviews: 98, color: '#3b82f6' },
//                 { category: 'Packaging', rating: 4.5, reviews: 87, color: '#f59e0b' },
//                 { category: 'Customer Service', rating: 4.3, reviews: 76, color: '#8b5cf6' },
//                 { category: 'Value for Money', rating: 4.4, reviews: 92, color: '#ec4899' }
//             ],
//             commonIssues: [
//                 { issue: 'Late Delivery', count: 23, percentage: 12 },
//                 { issue: 'Wrong Order', count: 15, percentage: 8 },
//                 { issue: 'Food Temperature', count: 12, percentage: 6 },
//                 { issue: 'Packaging Damaged', count: 8, percentage: 4 },
//                 { issue: 'Payment Issues', count: 5, percentage: 3 }
//             ]
//         };
//     }, [generateDateTrendData]);


//     const TimeRangeTotalsDisplay = () => {
//         // ✅ Get totals from state (fetched from APIs)
//         const totals = customTotals || {};

//         const formatCurrency = (num) => {
//             if (typeof num !== 'number' || isNaN(num)) {
//                 return `₹0`;
//             }
//             return `₹${num.toLocaleString("en-IN")}`;
//         };

//         const metrics = [
//             {
//                 label: "Revenue",
//                 value: formatCurrency(totals.revenue || 0),
//                 icon: <span style={{ fontSize: "18px", fontWeight: "700" }}>₹</span>,
//                 color: "#10b981",
//                 bgColor: "#dcfce7",
//                 description: "All-time Total Revenue"
//             },
//             {
//                 label: "Orders",
//                 value: totals.orders
//                     ? totals.orders.toLocaleString("en-IN")
//                     : "0",
//                 icon: <ShoppingBag size={10} />,
//                 color: "#f59e0b",
//                 bgColor: "#fef3c7",
//                 description: "All-time Total Orders"
//             },
//             {
//                 label: "Rating",
//                 value: `${Number(totals.avgRating || 0).toFixed(1)}/5`,
//                 icon: <StarIcon size={10} />,
//                 color: "#3b82f6",
//                 bgColor: "#dbeafe",
//                 description: startDate && endDate
//                     ? `Rating for ${formatDate(startDate)} to ${formatDate(endDate)}`
//                     : "All-time Average Rating"
//             },
//         ];

//         const metricCount = metrics.length;

//         return (
//             <div
//                 style={{
//                     display: "grid",
//                     gridTemplateColumns: isMobile
//                         ? (metricCount <= 2 ? "repeat(2, 1fr)" : "repeat(2, 1fr)")
//                         : (metricCount <= 3 ? `repeat(${metricCount}, minmax(0, 200px))` : "repeat(4, 1fr)"),
//                     gap: isMobile ? "6px" : "8px",
//                     marginTop: "-15px",
//                     padding: "8px",
//                     justifyContent: "center",
//                     justifyItems: "center",
//                 }}
//             >
//                 {metrics.map((metric, index) => (
//                     <div
//                         key={index}
//                         style={{
//                             textAlign: "center",
//                             padding: "8px 6px",
//                             background: metric.bgColor,
//                             borderRadius: "8px",
//                             border: `1px solid ${metric.color}20`,
//                             minHeight: "60px",
//                             width: isMobile ? "100%" : "180px",
//                             maxWidth: "250px",
//                             position: "relative",
//                             cursor: "help",
//                         }}
//                         title={metric.description} // Tooltip on hover
//                     >
//                         <div
//                             style={{
//                                 fontSize: isMobile ? "8px" : "9px",
//                                 color: metric.color,
//                                 fontWeight: "600",
//                                 marginBottom: "3px",
//                                 textTransform: "uppercase",
//                                 letterSpacing: "0.3px",
//                                 display: "flex",
//                                 alignItems: "center",
//                                 justifyContent: "center",
//                                 gap: "3px",
//                             }}
//                         >
//                             {metric.icon}
//                             {metric.label}
//                         </div>

//                         <div
//                             style={{
//                                 fontSize: isMobile ? "14px" : "16px",
//                                 fontWeight: "800",
//                                 color: "#1e293b",
//                                 marginBottom: "3px",
//                                 lineHeight: "1.2",
//                             }}
//                         >
//                             {metric.value}
//                         </div>

//                         <div
//                             style={{
//                                 fontSize: isMobile ? "7px" : "8px",
//                                 color: metric.color,
//                                 opacity: 0.7,
//                             }}
//                         >
//                             {metric.label === "Rating" && startDate && endDate
//                                 ? "Custom Range"
//                                 : metric.label === "Rating"
//                                     ? "All Time"
//                                     : "All Time"}
//                         </div>
//                     </div>
//                 ))}
//             </div>
//         );
//     };


//     // View Toggles
//     const ViewToggles = () => (
//         <div style={{
//             marginTop: '6px',
//             display: 'flex',
//             gap: isMobile ? '4px' : '8px',
//             background: 'transparent',
//             padding: isMobile ? '3px' : '4px',
//             borderRadius: '12px',
//             justifyContent: isMobile ? 'space-around' : 'center',
//             overflowX: isMobile ? 'auto' : 'visible',
//             flexWrap: 'wrap'
//         }}>
//             {[
//                 { key: 'revenueExpenses', label: 'Financials', icon: <Scale size={16} />, color: '#3b82f6' },
//                 { key: 'revenue', label: 'Revenue', icon: <DollarSign size={16} />, color: '#10b981' },
//                 // { key: 'expenses', label: 'Expenses', icon: <Calculator size={16} />, color: '#ef4444' },
//                 { key: 'orders', label: 'Orders', icon: <ShoppingBag size={16} />, color: '#f59e0b' },
//                 { key: 'payments', label: 'Payments', icon: <CreditCardIcon size={16} />, color: '#7c3aed' },
//                 { key: 'ratings', label: 'Ratings', icon: <StarIcon size={16} />, color: '#8b5cf6' }
//             ].map(view => (
//                 <button
//                     key={view.key}
//                     onClick={() => setActiveView(view.key)}
//                     style={{
//                         padding: isMobile ? '10px 12px' : '10px 16px',
//                         background: activeView === view.key ?
//                             `linear-gradient(135deg, ${view.color} 0%, ${view.color}80 100%)` :
//                             'white',
//                         color: activeView === view.key ? 'white' : view.color,
//                         border: `2px solid ${activeView === view.key ? view.color : view.color}20`,
//                         borderRadius: '12px',
//                         fontSize: isMobile ? '12px' : '14px',
//                         fontWeight: activeView === view.key ? '700' : '600',
//                         cursor: 'pointer',
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: '6px',
//                         flexShrink: 0,
//                         boxShadow: activeView === view.key ?
//                             `0 4px 12px ${view.color}40` :
//                             '0 2px 8px rgba(0,0,0,0.05)',
//                         minWidth: isMobile ? '90px' : '110px',
//                         justifyContent: 'center',
//                         height: '44px',
//                         transition: 'all 0.2s ease',
//                         marginBottom: isMobile ? '3px' : '0',
//                         whiteSpace: 'nowrap'
//                     }}
//                     onMouseEnter={(e) => {
//                         if (activeView !== view.key) {
//                             e.currentTarget.style.background = `${view.color}10`;
//                             e.currentTarget.style.borderColor = view.color;
//                         }
//                     }}
//                     onMouseLeave={(e) => {
//                         if (activeView !== view.key) {
//                             e.currentTarget.style.background = 'white';
//                             e.currentTarget.style.borderColor = `${view.color}20`;
//                         }
//                     }}
//                 >
//                     {view.icon}
//                     {view.label}
//                 </button>
//             ))}
//         </div>
//     );

//     // ========== MAIN RENDER ==========

//     if (loading) {
//         return (
//             <div style={{
//                 height: "100vh",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
//             }}>
//                 <div style={{
//                     width: '60px',
//                     height: '60px',
//                     border: '4px solid rgba(255, 255, 255, 0.3)',
//                     borderTopColor: 'white',
//                     borderRadius: '50%',
//                     animation: 'spin 1s linear infinite'
//                 }}></div>
//             </div>
//         );
//     };

//     return (
//         <div style={{
//             height: '100vh',
//             display: 'flex',
//             flexDirection: 'column',
//             fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
//             overflow: 'hidden'
//         }}>
//             {/* Header */}
//             <div style={{
//                 background: 'white',
//                 padding: isMobile ? '16px 20px' : '20px 28px',
//                 top: '-20px',
//                 zIndex: 100,
//                 marginTop: '-20px',
//                 flexShrink: 0
//             }} className="main-sticky-scroll-mobile">
//                 <div style={{
//                     display: 'flex',
//                     justifyContent: 'space-between',
//                     alignItems: 'center',
//                     marginBottom: '16px'
//                 }}>


//                     {isMobile && (
//                         <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
//                             <button
//                                 onClick={() => setShowMobileMenu(!showMobileMenu)}
//                                 style={{
//                                     width: '44px',
//                                     height: '44px',
//                                     background: colors.gradient,
//                                     color: 'white',
//                                     border: 'none',
//                                     borderRadius: '12px',
//                                     cursor: 'pointer',
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     justifyContent: 'center',
//                                     boxShadow: '0 4px 12px rgba(124, 58, 237, 0.3)'
//                                 }}
//                             >
//                                 <Menu size={22} />
//                             </button>
//                         </div>
//                     )}
//                 </div>

//                 {/* Time Range + Export/Reset */}
//                 <div style={{
//                     display: 'flex',
//                     flexDirection: isMobile ? 'column' : 'row',
//                     gap: isMobile ? '12px' : '16px',
//                     alignItems: 'center',
//                     top: '-21px',
//                     justifyContent: 'space-between',
//                     position: 'relative'
//                 }}>
//                     {/* Time Range Selector */}
//                     <div style={{
//                         display: 'flex',
//                         gap: isMobile ? '6px' : '15px',
//                         background: 'transparent',
//                         padding: isMobile ? '4px' : '6px',
//                         borderRadius: '16px',
//                         width: isMobile ? '100%' : 'auto',
//                         flexWrap: 'wrap',
//                         position: 'relative'
//                     }}>
//                         {[
//                             // { key: 'yearly', label: isMobile ? 'Year' : 'Yearly', icon: <CalendarIcon size={16} />, color: '#7c3aed' },
//                             // { key: 'monthly', label: isMobile ? 'Month' : 'Monthly', icon: <CalendarIcon size={16} />, color: '#10b981' },
//                             // { key: 'weekly', label: isMobile ? 'Week' : 'Weekly', icon: <CalendarIcon size={16} />, color: '#3b82f6' },
//                             { key: 'custom', label: isMobile ? 'Custom' : 'Custom Range', icon: <CalendarIcon size={16} />, color: '#ef4444' }
//                         ].map(range => (
//                             <div key={range.key} style={{ position: 'relative' }}>
//                                 <button
//                                     onClick={() => {
//                                         if (range.key === 'custom') {
//                                             setTimeRange('custom');
//                                             setShowDatePicker(!showDatePicker);
//                                             setTimeFilter(null);
//                                         } else {
//                                             // Set timeRange immediately when button is clicked
//                                             setTimeRange(range.key);
//                                             // Show filter dropdown
//                                             setTimeFilter(timeFilter === range.key ? null : range.key);
//                                             setShowDatePicker(false);
//                                         }
//                                     }}
//                                     style={{
//                                         padding: isMobile ? '8px 12px' : '10px 10px',
//                                         background: timeRange === range.key ?
//                                             `linear-gradient(135deg, ${range.color} 0%, ${range.color}80 100%)` :
//                                             'white',
//                                         color: timeRange === range.key ? 'white' : range.color,
//                                         border: `2px solid ${timeRange === range.key ? range.color : range.color}20`,
//                                         borderRadius: '12px',
//                                         fontSize: isMobile ? '12px' : '14px',
//                                         fontWeight: timeRange === range.key ? '700' : '600',
//                                         cursor: 'pointer',
//                                         display: 'flex',
//                                         alignItems: 'center',
//                                         gap: '6px',
//                                         whiteSpace: 'nowrap',
//                                         flex: isMobile ? '1' : 'none',
//                                         position: 'relative',
//                                         zIndex: 1,
//                                         transition: 'all 0.3s ease',
//                                         boxShadow: timeRange === range.key ?
//                                             `0 4px 12px ${range.color}40` :
//                                             '0 2px 8px rgba(0,0,0,0.05)',
//                                         minWidth: isMobile ? '80px' : '100px',
//                                         justifyContent: 'center'
//                                     }}
//                                     onMouseEnter={(e) => {
//                                         if (timeRange !== range.key) {
//                                             e.currentTarget.style.background = `${range.color}10`;
//                                             e.currentTarget.style.borderColor = range.color;
//                                         }
//                                     }}
//                                     onMouseLeave={(e) => {
//                                         if (timeRange !== range.key) {
//                                             e.currentTarget.style.background = 'white';
//                                             e.currentTarget.style.borderColor = `${range.color}20`;
//                                         }
//                                     }}
//                                 >
//                                     {range.icon}
//                                     {range.label}
//                                 </button>

//                                 {/* Individual Filter Popup for each button */}
//                                 {timeFilter === range.key && (
//                                     <div style={{
//                                         position: 'absolute',
//                                         top: 'calc(100% + 10px)',
//                                         left: '0',
//                                         background: 'white',
//                                         borderRadius: '16px',
//                                         border: '1px solid #e2e8f0',
//                                         boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
//                                         zIndex: 1001,
//                                         minWidth: '200px',
//                                         maxWidth: '280px',
//                                         maxHeight: '350px',
//                                         overflowY: 'auto',
//                                         animation: 'slideDown 0.2s ease'
//                                     }}>
//                                         <div style={{
//                                             padding: '16px',
//                                             borderBottom: '1px solid #e2e8f0',
//                                             background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)'
//                                         }}>
//                                             <h4 style={{
//                                                 fontSize: '14px',
//                                                 fontWeight: '700',
//                                                 color: '#1e293b',
//                                                 marginBottom: '12px',
//                                                 display: 'flex',
//                                                 alignItems: 'center',
//                                                 gap: '8px'
//                                             }}>
//                                                 {range.key === 'yearly' ? <CalendarIcon size={16} /> :
//                                                     range.key === 'monthly' ? <CalendarIcon size={16} /> :
//                                                         <CalendarIcon size={16} />}
//                                                 Select {range.key}
//                                             </h4>

//                                             {range.key === 'yearly' && (
//                                                 <div style={{
//                                                     display: 'flex',
//                                                     flexDirection: 'column',
//                                                     gap: '8px'
//                                                 }}>
//                                                     {['2024', '2023', '2022', '2021', '2020'].map(year => (
//                                                         <button
//                                                             key={year}
//                                                             onClick={() => {
//                                                                 selectYear(year);
//                                                                 setTimeRange('yearly');
//                                                                 setTimeFilter(null);
//                                                             }}
//                                                             style={{
//                                                                 padding: '12px 16px',
//                                                                 background: selectedYear === year ?
//                                                                     'linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%)' :
//                                                                     'white',
//                                                                 color: selectedYear === year ? 'white' : '#475569',
//                                                                 border: selectedYear === year ? 'none' : '1px solid #e2e8f0',
//                                                                 borderRadius: '10px',
//                                                                 fontSize: '14px',
//                                                                 textAlign: 'left',
//                                                                 cursor: 'pointer',
//                                                                 transition: 'all 0.2s',
//                                                                 fontWeight: selectedYear === year ? '600' : '400',
//                                                                 display: 'flex',
//                                                                 alignItems: 'center',
//                                                                 justifyContent: 'space-between'
//                                                             }}
//                                                             onMouseEnter={(e) => {
//                                                                 if (selectedYear !== year) {
//                                                                     e.currentTarget.style.background = '#f8fafc';
//                                                                     e.currentTarget.style.borderColor = '#7c3aed';
//                                                                     e.currentTarget.style.color = '#7c3aed';
//                                                                 }
//                                                             }}
//                                                             onMouseLeave={(e) => {
//                                                                 if (selectedYear !== year) {
//                                                                     e.currentTarget.style.background = 'white';
//                                                                     e.currentTarget.style.borderColor = '#e2e8f0';
//                                                                     e.currentTarget.style.color = '#475569';
//                                                                 }
//                                                             }}
//                                                         >
//                                                             {year}
//                                                             {selectedYear === year && (
//                                                                 <CheckCircle size={16} color="white" />
//                                                             )}
//                                                         </button>
//                                                     ))}
//                                                 </div>
//                                             )}

//                                             {range.key === 'monthly' && (
//                                                 <div style={{
//                                                     display: 'grid',
//                                                     gridTemplateColumns: 'repeat(3, 1fr)',
//                                                     gap: '8px'
//                                                 }}>
//                                                     {[
//                                                         { value: '01', label: 'Jan' }, { value: '02', label: 'Feb' }, { value: '03', label: 'Mar' },
//                                                         { value: '04', label: 'Apr' }, { value: '05', label: 'May' }, { value: '06', label: 'Jun' },
//                                                         { value: '07', label: 'Jul' }, { value: '08', label: 'Aug' }, { value: '09', label: 'Sep' },
//                                                         { value: '10', label: 'Oct' }, { value: '11', label: 'Nov' }, { value: '12', label: 'Dec' }
//                                                     ].map(month => (
//                                                         <button
//                                                             key={month.value}
//                                                             onClick={() => {
//                                                                 selectMonth(month.value);
//                                                                 setTimeRange('monthly');
//                                                                 setTimeFilter(null);
//                                                             }}
//                                                             style={{
//                                                                 padding: '12px 8px',
//                                                                 background: selectedMonth === month.value ?
//                                                                     'linear-gradient(135deg, #10b981 0%, #059669 100%)' :
//                                                                     'white',
//                                                                 color: selectedMonth === month.value ? 'white' : '#475569',
//                                                                 border: selectedMonth === month.value ? 'none' : '1px solid #e2e8f0',
//                                                                 borderRadius: '10px',
//                                                                 fontSize: '13px',
//                                                                 cursor: 'pointer',
//                                                                 transition: 'all 0.2s',
//                                                                 fontWeight: selectedMonth === month.value ? '600' : '400',
//                                                                 display: 'flex',
//                                                                 justifyContent: 'center',
//                                                                 alignItems: 'center',
//                                                                 flexDirection: 'column',
//                                                                 gap: '4px'
//                                                             }}
//                                                             onMouseEnter={(e) => {
//                                                                 if (selectedMonth !== month.value) {
//                                                                     e.currentTarget.style.background = '#f8fafc';
//                                                                     e.currentTarget.style.borderColor = '#10b981';
//                                                                     e.currentTarget.style.color = '#10b981';
//                                                                 }
//                                                             }}
//                                                             onMouseLeave={(e) => {
//                                                                 if (selectedMonth !== month.value) {
//                                                                     e.currentTarget.style.background = 'white';
//                                                                     e.currentTarget.style.borderColor = '#e2e8f0';
//                                                                     e.currentTarget.style.color = '#475569';
//                                                                 }
//                                                             }}
//                                                         >
//                                                             {month.label}
//                                                             {selectedMonth === month.value && (
//                                                                 <div style={{
//                                                                     width: '6px',
//                                                                     height: '6px',
//                                                                     borderRadius: '50%',
//                                                                     background: 'white'
//                                                                 }}></div>
//                                                             )}
//                                                         </button>
//                                                     ))}
//                                                 </div>
//                                             )}

//                                             {range.key === 'weekly' && (
//                                                 <div style={{
//                                                     display: 'flex',
//                                                     flexDirection: 'column',
//                                                     gap: '8px'
//                                                 }}>
//                                                     {['This Week', 'Last Week', 'Week 1', 'Week 2', 'Week 3', 'Week 4'].map(week => (
//                                                         <button
//                                                             key={week}
//                                                             onClick={() => {
//                                                                 selectWeek(week);
//                                                                 setTimeRange('weekly');
//                                                                 setTimeFilter(null);
//                                                             }}
//                                                             style={{
//                                                                 padding: '12px 16px',
//                                                                 background: selectedWeek === week ?
//                                                                     'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)' :
//                                                                     'white',
//                                                                 color: selectedWeek === week ? 'white' : '#475569',
//                                                                 border: selectedWeek === week ? 'none' : '1px solid #e2e8f0',
//                                                                 borderRadius: '10px',
//                                                                 fontSize: '14px',
//                                                                 textAlign: 'left',
//                                                                 cursor: 'pointer',
//                                                                 transition: 'all 0.2s',
//                                                                 fontWeight: selectedWeek === week ? '600' : '400',
//                                                                 display: 'flex',
//                                                                 alignItems: 'center',
//                                                                 justifyContent: 'space-between'
//                                                             }}
//                                                             onMouseEnter={(e) => {
//                                                                 if (selectedWeek !== week) {
//                                                                     e.currentTarget.style.background = '#f8fafc';
//                                                                     e.currentTarget.style.borderColor = '#3b82f6';
//                                                                     e.currentTarget.style.color = '#3b82f6';
//                                                                 }
//                                                             }}
//                                                             onMouseLeave={(e) => {
//                                                                 if (selectedWeek !== week) {
//                                                                     e.currentTarget.style.background = 'white';
//                                                                     e.currentTarget.style.borderColor = '#e2e8f0';
//                                                                     e.currentTarget.style.color = '#475569';
//                                                                 }
//                                                             }}
//                                                         >
//                                                             {week}
//                                                             {selectedWeek === week && (
//                                                                 <CheckCircle size={16} color="white" />
//                                                             )}
//                                                         </button>
//                                                     ))}
//                                                 </div>
//                                             )}
//                                         </div>

//                                         <div style={{
//                                             padding: '12px 16px',
//                                             background: '#f8fafc',
//                                             borderTop: '1px solid #e2e8f0',
//                                             borderBottomLeftRadius: '16px',
//                                             borderBottomRightRadius: '16px'
//                                         }}>
//                                             <button
//                                                 onClick={() => setTimeFilter(null)}
//                                                 style={{
//                                                     width: '100%',
//                                                     padding: '10px',
//                                                     background: 'white',
//                                                     color: '#64748b',
//                                                     border: '1px solid #e2e8f0',
//                                                     borderRadius: '8px',
//                                                     fontSize: '13px',
//                                                     fontWeight: '500',
//                                                     cursor: 'pointer',
//                                                     display: 'flex',
//                                                     alignItems: 'center',
//                                                     justifyContent: 'center',
//                                                     gap: '8px',
//                                                     transition: 'all 0.2s'
//                                                 }}
//                                                 onMouseEnter={(e) => {
//                                                     e.currentTarget.style.background = '#f1f5f9';
//                                                     e.currentTarget.style.color = '#475569';
//                                                 }}
//                                                 onMouseLeave={(e) => {
//                                                     e.currentTarget.style.background = 'white';
//                                                     e.currentTarget.style.color = '#64748b';
//                                                 }}
//                                             >
//                                                 <X size={14} />
//                                                 Close
//                                             </button>
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>
//                         ))}
//                     </div>

//                     {/* Add click outside handler for popups */}
//                     {timeFilter && (
//                         <div
//                             onClick={() => setTimeFilter(null)}
//                             style={{
//                                 position: 'fixed',
//                                 top: 0,
//                                 left: 0,
//                                 right: 0,
//                                 bottom: 0,
//                                 zIndex: 1000,
//                                 // No background, just for click detection
//                             }}
//                         />
//                     )}

//                     {/* Date Picker Modal with Today Button */}
//                     {showDatePicker && (
//                         <div style={{
//                             position: 'absolute',
//                             top: 'calc(100% + 3px)',
//                             left: isMobile ? '16px' : '270px',
//                             right: isMobile ? '16px' : 'calc(100% - 320px)',
//                             background: 'white',
//                             padding: '12px',
//                             borderRadius: '12px',
//                             border: '1px solid #e2e8f0',
//                             boxShadow: '0 6px 24px rgba(0,0,0,0.1)',
//                             zIndex: 1001,
//                             width: isMobile ? 'calc(100% - 32px)' : '280px'
//                         }}>
//                             <div style={{
//                                 display: 'flex',
//                                 gap: '8px',
//                                 alignItems: 'center',
//                                 marginBottom: '12px',
//                                 flexWrap: 'nowrap'
//                             }}>
//                                 <div style={{ flex: 1, minWidth: 0 }}>
//                                     <input
//                                         type="date"
//                                         value={startDate}
//                                         onChange={(e) => setStartDate(e.target.value)}
//                                         style={{
//                                             width: '100%',
//                                             padding: '6px 8px',
//                                             border: '1px solid #e2e8f0',
//                                             borderRadius: '6px',
//                                             fontSize: '12px',
//                                             outline: 'none',
//                                             boxSizing: 'border-box'
//                                         }}
//                                     />
//                                 </div>
//                                 <span style={{
//                                     color: '#94a3b8',
//                                     fontSize: '11px',
//                                     flexShrink: 0,
//                                     minWidth: '20px',
//                                     textAlign: 'center'
//                                 }}>
//                                     to
//                                 </span>
//                                 <div style={{ flex: 1, minWidth: 0 }}>
//                                     <input
//                                         type="date"
//                                         value={endDate}
//                                         onChange={(e) => setEndDate(e.target.value)}
//                                         style={{
//                                             width: '100%',
//                                             padding: '6px 8px',
//                                             border: '1px solid #e2e8f0',
//                                             borderRadius: '6px',
//                                             fontSize: '12px',
//                                             outline: 'none',
//                                             boxSizing: 'border-box'
//                                         }}
//                                     />
//                                 </div>
//                             </div>

//                             <div style={{
//                                 display: 'flex',
//                                 gap: '8px',
//                                 marginBottom: '12px',
//                                 flexWrap: 'wrap'
//                             }}>
//                                 <button
//                                     onClick={() => {
//                                         const today = new Date();
//                                         const todayStr = today.toISOString().split('T')[0];
//                                         setStartDate(todayStr);
//                                         setEndDate(todayStr);
//                                     }}
//                                     style={{
//                                         flex: '1 1 100px',
//                                         padding: '6px 8px',
//                                         background: '#f1f5f9',
//                                         color: '#3b82f6',
//                                         border: '1px solid #e2e8f0',
//                                         borderRadius: '6px',
//                                         fontSize: '12px',
//                                         fontWeight: '500',
//                                         cursor: 'pointer',
//                                         display: 'flex',
//                                         alignItems: 'center',
//                                         justifyContent: 'center',
//                                         gap: '4px',
//                                         minWidth: 0
//                                     }}
//                                 >
//                                     <Clock size={12} />
//                                     Today
//                                 </button>

//                                 {startDate && endDate && (
//                                     <div style={{
//                                         flex: '1 1 100px',
//                                         padding: '6px 8px',
//                                         background: '#f8fafc',
//                                         borderRadius: '6px',
//                                         fontSize: '11px',
//                                         color: '#64748b',
//                                         textAlign: 'center',
//                                         display: 'flex',
//                                         alignItems: 'center',
//                                         justifyContent: 'center',
//                                         minWidth: 0
//                                     }}>
//                                         {getDaysDifference(startDate, endDate)} days
//                                     </div>
//                                 )}
//                             </div>

//                             <div style={{
//                                 display: 'flex',
//                                 gap: '8px'
//                             }}>
//                                 <button
//                                     onClick={() => {
//                                         handleDateRangeApply();
//                                         setShowDatePicker(false);
//                                     }}
//                                     disabled={!startDate || !endDate}
//                                     style={{
//                                         flex: 1,
//                                         padding: '6px',
//                                         background: colors.primary,
//                                         color: 'white',
//                                         border: 'none',
//                                         borderRadius: '6px',
//                                         fontSize: '12px',
//                                         fontWeight: '600',
//                                         cursor: (!startDate || !endDate) ? 'not-allowed' : 'pointer',
//                                         opacity: (!startDate || !endDate) ? 0.5 : 1,
//                                         minWidth: 0
//                                     }}
//                                 >
//                                     Apply
//                                 </button>
//                                 <button
//                                     onClick={() => {
//                                         handleDateRangeCancel();
//                                         setShowDatePicker(false);
//                                     }}
//                                     style={{
//                                         flex: 1,
//                                         padding: '6px',
//                                         background: 'transparent',
//                                         color: '#64748b',
//                                         border: '1px solid #e2e8f0',
//                                         borderRadius: '6px',
//                                         fontSize: '12px',
//                                         fontWeight: '500',
//                                         cursor: 'pointer',
//                                         minWidth: 0
//                                     }}
//                                 >
//                                     Cancel
//                                 </button>
//                             </div>
//                         </div>
//                     )}

//                     {/* Export and Reset Buttons */}
//                     <div style={{ display: 'flex', gap: '8px', width: isMobile ? '100%' : 'auto' }}>
//                         <button
//                             onClick={handleReset}
//                             disabled={resetting}
//                             style={{
//                                 padding: isMobile ? '10px 16px' : '12px 20px',
//                                 background: resetting ? '#94a3b8' : '#f59e0b',
//                                 color: 'white',
//                                 border: 'none',
//                                 borderRadius: '12px',
//                                 fontSize: isMobile ? '13px' : '14px',
//                                 fontWeight: '600',
//                                 cursor: resetting ? 'not-allowed' : 'pointer',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 gap: '8px',
//                                 flex: isMobile ? 1 : 'none',
//                                 justifyContent: 'center'
//                             }}
//                         >
//                             <RotateCcw size={isMobile ? 16 : 18} className={resetting ? 'spin' : ''} />
//                             {resetting ? '...' : 'Reset'}
//                         </button>
//                         <button
//                             onClick={() => {
//                                 // Export functionality
//                                 const exportData = generateDateTrendData;
//                                 const ws = XLSX.utils.json_to_sheet(exportData);
//                                 const wb = XLSX.utils.book_new();
//                                 XLSX.utils.book_append_sheet(wb, ws, "Report");
//                                 XLSX.writeFile(wb, `Analytics_${timeRange}_${new Date().toISOString().split('T')[0]}.xlsx`);
//                             }}
//                             style={{
//                                 padding: isMobile ? '10px 16px' : '12px 20px',
//                                 background: colors.gradient,
//                                 color: 'white',
//                                 border: 'none',
//                                 borderRadius: '12px',
//                                 fontSize: isMobile ? '13px' : '14px',
//                                 fontWeight: '600',
//                                 cursor: 'pointer',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 gap: '8px',
//                                 flex: isMobile ? 1 : 'none',
//                                 justifyContent: 'center'
//                             }}
//                         >
//                             <Download size={isMobile ? 16 : 18} />
//                             Export
//                         </button>
//                     </div>
//                 </div>

//                 {/* Time Range Totals Display - Shows totals for selected time range */}
//                 <TimeRangeTotalsDisplay />

//                 {/* View Toggles */}
//                 <ViewToggles />
//             </div>

//             {/* Content Area */}
//             <div style={{
//                 flex: 1,
//                 overflowY: 'auto',
//                 overflowX: 'hidden',
//                 marginBottom: '70px',
//                 padding: isMobile ? '20px' : '28px',
//                 position: 'relative',
//                 WebkitOverflowScrolling: 'touch'
//             }}>
//                 {/* Render content based on active view */}
//                 {activeView === 'revenueExpenses' && (
//                     <Financials
//                         isMobile={isMobile}
//                         colors={colors}
//                         generateDateTrendData={generateDateTrendData}
//                         generateExpenseTrendData={generateExpenseTrendData}
//                         startDate={startDate}     // ✅ ADD THIS
//                         endDate={endDate}         // ✅ ADD THIS
//                     />
//                 )}


//                 {activeView === 'revenue' && (
//                     <Revenue
//                         isMobile={isMobile}
//                         colors={colors}
//                         generateDateTrendData={generateDateTrendData}
//                         generateOrderTypeData={generateOrderTypeData}
//                         generateCategoryData={generateCategoryData}
//                         generateTopItemsData={generateTopItemsData}
//                         generatePaymentData={generatePaymentData}
//                         generateGrossNetData={generateGrossNetData}
//                         generateDiscountImpactData={generateDiscountImpactData}
//                         startDate={startDate}     // ✅ ADD THIS
//                         endDate={endDate}         // ✅ ADD THIS
//                     />
//                 )}

//                 {/* {activeView === 'expenses' && (
//                     <Expenses
//                         isMobile={isMobile}
//                         colors={colors}
//                         generateExpenseTrendData={generateExpenseTrendData}
//                         generateExpenseData={generateExpenseData}
//                     />
//                 )} */}

//                 {activeView === 'orders' && (
//                     <Orders
//                         isMobile={isMobile}
//                         colors={colors}
//                         generateOrdersData={generateOrdersData}
//                     />
//                 )}

//                 {activeView === 'payments' && (
//                     <Payments
//                         isMobile={isMobile}
//                         colors={colors}
//                         generatePaymentModeData={generatePaymentModeData}
//                     />
//                 )}

//                 {activeView === 'ratings' && (
//                     <Ratings
//                         isMobile={isMobile}
//                         colors={colors}
//                         generateRatingsData={generateRatingsData}
//                     />
//                 )}

//                 {/* Bottom padding */}
//                 <div style={{ height: isMobile ? '100px' : '60px' }}></div>
//             </div>

//             <style>{`
//                 @keyframes spin {
//                     0% { transform: rotate(0deg); }
//                     100% { transform: rotate(360deg); }
//                 }
//                 .spin {
//                     animation: spin 1s linear infinite;
//                 }
//                 ::-webkit-scrollbar { display: none; }
//             `}</style>
//         </div>
//     );
// };

// export default StandardReport;






import React, { useEffect, useState, useMemo } from "react";
import {
    BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
    ResponsiveContainer, PieChart, Pie, Cell, LineChart, Line,
    ComposedChart, Area, AreaChart, RadialBarChart, RadialBar
} from "recharts";
import {
    TrendingUp, TrendingDown, DollarSign, ShoppingBag, Package,
    Users, CreditCard, CheckCircle, Calculator,
    Building, Tag, Truck, FileText, Utensils, Coffee, Pizza,
    Cake, ShoppingCart, Calendar as CalendarIcon, Target,
    BarChart as BarChartIcon, PieChart as PieChartIcon,
    LineChart as LineChartIcon, AlertCircle, Shield,
    Activity, Scale, Wallet, ChevronDown, X, Menu,
    Download, Filter, Sparkles, Crown, Trophy, Zap, TrendingUp as TrendUp,
    RotateCcw, Star, Clock, PackageOpen, UserCheck,
    MessageSquare, ThumbsUp, Award, BarChart2, CreditCard as CreditCardIcon,
    Star as StarIcon, BarChart3, PieChart as PieChartIcon2, LineChart as LineChartIcon2,
    Percent, DollarSign as DollarSignIcon, CheckSquare
} from 'lucide-react';
import axios from "axios";
import * as XLSX from 'xlsx';
import "./StandardReport.css";

import Revenue from "./Revenue";
import Ratings from "./Ratings";
import Financials from "./Financials";
import Expenses from "./Expenses";
import Orders from "./Orders";
import Payments from "./Payments";

const StandardReport = () => {
    const [vendorId, setVendorId] = useState(null);
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const [timeRange, setTimeRange] = useState('monthly');
    const [showMobileMenu, setShowMobileMenu] = useState(false);
    const [activeView, setActiveView] = useState('revenue');
    const [resetting, setResetting] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [timeFilter, setTimeFilter] = useState(null);
    const [selectedYear, setSelectedYear] = useState(null);
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [selectedWeek, setSelectedWeek] = useState(null);
    const [customTotals, setCustomTotals] = useState(null);
    const [loadingStats, setLoadingStats] = useState(false);



    const [startDate, setStartDate] = useState(() => {
        const date = new Date();
        date.setDate(date.getDate() - 30);
        return date.toISOString().split("T")[0]; // YYYY-MM-DD
    });

    const [endDate, setEndDate] = useState(() => {
        return new Date().toISOString().split("T")[0]; // YYYY-MM-DD
    });

    const fetchData = async () => {
        const vendorId = localStorage.getItem("vendorId");
        const authToken = localStorage.getItem("authToken");

        if (!vendorId || !authToken) {
            alert("❌ Missing vendorId / token");
            return;
        }

        setLoading(true);
        setResetting(true);

        try {
            // 1. Get ALL-TIME totals (orders & revenue)
            const allTimeRes = await axios.get(
                `https://backend.maamaas.com/food/api/orders/vendor/statistics/${vendorId}`,
                {
                    headers: { Authorization: `Bearer ${authToken}` }
                }
            );

            const allTimeData = allTimeRes.data;

            // 2. Get CUSTOM DATE RANGE rating
            let customRating = 0;

            // Only fetch custom rating if we have date range selected
            if (startDate && endDate) {
                try {
                    const customRes = await axios.get(
                        `https://backend.maamaas.com/food/api/orders/vendor/statistics/custom` +
                        `?vendorId=${vendorId}&fromDate=${startDate}&toDate=${endDate}`,
                        {
                            headers: { Authorization: `Bearer ${authToken}` }
                        }
                    );

                    customRating = Number(customRes.data.averageRating) || 0;
                } catch (customErr) {
                    console.warn("⚠️ Could not fetch custom rating, using all-time rating");
                    customRating = Number(allTimeData.averageRating) || 0;
                }
            } else {
                // Use all-time rating if no date range
                customRating = Number(allTimeData.averageRating) || 0;
            }

            // Combine the data
            const mappedTotals = {
                revenue: allTimeData.totalRevenue ?? 0,           // From ALL-TIME API
                orders: allTimeData.totalOrders ?? 0,             // From ALL-TIME API
                avgRating: customRating,                          // From CUSTOM API (or all-time)
            };


            setCustomTotals(mappedTotals);

            // If we have a date range selected, show "custom", otherwise show "all-time"
            if (startDate && endDate) {
                setTimeRange("custom");
            }

        } catch (err) {
            console.error("❌ Error fetching report:", err);
            alert("❌ Error fetching data. Check console.");
        } finally {
            setLoading(false);
            setResetting(false);
        }
    };





    const fetchCustomRangeTotals = async (fromDate, toDate) => {
        if (!vendorId || !fromDate || !toDate) return;

        setLoadingStats(true);

        try {
            const token = localStorage.getItem("authToken");

            // 1. Get all-time totals for orders and revenue
            const allTimeRes = await fetch(
                `https://backend.maamaas.com/food/api/orders/vendor/statistics/${vendorId}`,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
            const allTimeData = await allTimeRes.json();

            // 2. Get custom date range rating
            const customRes = await fetch(
                `https://backend.maamaas.com/food/api/orders/vendor/statistics/custom?vendorId=${vendorId}&fromDate=${fromDate}&toDate=${toDate}`,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
            const customData = await customRes.json();

            // Combine data
            const mappedTotals = {
                revenue: allTimeData.totalRevenue || 0,            // From ALL-TIME API
                orders: allTimeData.totalOrders || 0,              // From ALL-TIME API
                avgRating: Number(customData.averageRating) || 0,  // From CUSTOM API
            };

            setCustomTotals(mappedTotals);
            setTimeRange("custom");

        } catch (err) {
            console.error("❌ Custom range API error:", err);
        } finally {
            setLoadingStats(false);
        }
    };


    // Enhanced color palette
    const colors = {
        primary: '#7c3aed', // Purple
        secondary: '#10b981', // Emerald
        accent: '#f59e0b', // Amber
        danger: '#ef4444', // Red
        info: '#3b82f6', // Blue
        success: '#10b981', // Green
        warning: '#f59e0b', // Yellow
        dark: '#1f2937',
        light: '#f9fafb',
        gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        gradient2: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
        gradient3: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
    };

    // Date range state
    const [showDatePicker, setShowDatePicker] = useState(false);


    // Responsive check
    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth < 768);
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    // Get vendor ID
    useEffect(() => {
        const storedVendorId = localStorage.getItem("vendorId");
        if (storedVendorId) setVendorId(storedVendorId);
    }, []);

    // Fetch data


    // Helper function to show time filter
    const showTimeFilter = (filterType) => {
        setTimeFilter(filterType);
        setShowDatePicker(false);

        // Set default selections
        const today = new Date();
        if (filterType === 'yearly') {
            setSelectedYear(today.getFullYear().toString());
        } else if (filterType === 'monthly') {
            setSelectedMonth((today.getMonth() + 1).toString().padStart(2, '0'));
        } else if (filterType === 'weekly') {
            setSelectedWeek('This Week');
        }
    };

    // Function to handle year selection
    const selectYear = (year) => {
        setSelectedYear(year);
        setTimeFilter(null);

        // Set date range for selected year
        const startDate = `${year}-01-01`;
        const endDate = `${year}-12-31`;
        setStartDate(startDate);
        setEndDate(endDate);
        setTimeRange('custom');

        // Fetch data for selected year
        fetchDataForRange(startDate, endDate);
    };

    // Function to handle month selection
    const selectMonth = (month) => {
        setSelectedMonth(month);
        setTimeFilter(null);

        const today = new Date();
        const year = today.getFullYear();
        const startDate = `${year}-${month}-01`;

        // Calculate last day of month
        const lastDay = new Date(year, parseInt(month), 0).getDate();
        const endDate = `${year}-${month}-${lastDay}`;

        setStartDate(startDate);
        setEndDate(endDate);
        setTimeRange('custom');

        // Fetch data for selected month
        fetchDataForRange(startDate, endDate);
    };

    // Function to handle week selection
    const selectWeek = (week) => {
        setSelectedWeek(week);
        setTimeFilter(null);

        const today = new Date();
        let startDate, endDate;

        if (week === 'This Week') {
            // Get current week's Monday to Sunday
            const day = today.getDay();
            const diff = today.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is Sunday
            const monday = new Date(today.setDate(diff));
            const sunday = new Date(monday);
            sunday.setDate(monday.getDate() + 6);

            startDate = monday.toISOString().split('T')[0];
            endDate = sunday.toISOString().split('T')[0];
        } else if (week === 'Last Week') {
            // Get last week's Monday to Sunday
            const lastWeek = new Date(today);
            lastWeek.setDate(today.getDate() - 7);
            const day = lastWeek.getDay();
            const diff = lastWeek.getDate() - day + (day === 0 ? -6 : 1);
            const monday = new Date(lastWeek.setDate(diff));
            const sunday = new Date(monday);
            sunday.setDate(monday.getDate() + 6);

            startDate = monday.toISOString().split('T')[0];
            endDate = sunday.toISOString().split('T')[0];
        } else {
            // For specific weeks, you can implement custom logic
            // This is a simplified version
            const weekNum = parseInt(week.split(' ')[1]);
            const year = today.getFullYear();

            // Simplified calculation - adjust based on your needs
            const month = Math.ceil(weekNum / 4);
            const weekInMonth = weekNum % 4 || 4;

            // Calculate approximate dates
            const startDay = (weekInMonth - 1) * 7 + 1;
            const endDay = Math.min(weekInMonth * 7, 30);

            startDate = `${year}-${month.toString().padStart(2, '0')}-${startDay.toString().padStart(2, '0')}`;
            endDate = `${year}-${month.toString().padStart(2, '0')}-${endDay.toString().padStart(2, '0')}`;
        }

        setStartDate(startDate);
        setEndDate(endDate);
        setTimeRange('custom');

        // Fetch data for selected week
        fetchDataForRange(startDate, endDate);
    };

    // Function to fetch data for a specific date range
    const fetchDataForRange = (start, end) => {
        // Your existing fetch logic adapted for specific date range
        // Call your API with start and end dates
    };
    // Add this useEffect to close filter when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (timeFilter && !event.target.closest('.time-filter-container')) {
                setTimeFilter(null);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [timeFilter]);
    // Reset function
    const handleReset = () => {
        setResetting(true);
        setTimeRange('monthly');
        const defaultStartDate = new Date();
        defaultStartDate.setDate(defaultStartDate.getDate() - 30);
        setStartDate(defaultStartDate.toISOString().split('T')[0]);
        setEndDate(new Date().toISOString().split('T')[0]);
        setActiveView('revenue');
        setShowDatePicker(false);
        if (isMobile) setShowMobileMenu(false);
        fetchData();
        setTimeout(() => setResetting(false), 1000);
    };

    useEffect(() => {
        fetchData();
    }, [vendorId]);

    // Handle date range change
    const handleDateRangeApply = () => {
        setShowDatePicker(false);
        setTimeRange("custom");

        fetchCustomRangeTotals(startDate, endDate);
    };


    const handleDateRangeCancel = () => {
        setShowDatePicker(false);
    };

    // Calculate days difference
    const getDaysDifference = (start, end) => {
        const startDate = new Date(start);
        const endDate = new Date(end);
        const timeDiff = endDate.getTime() - startDate.getTime();
        return Math.floor(timeDiff / (1000 * 3600 * 24)) + 1;
    };

    // Format date for display
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
    };

    // ========== DATA GENERATORS ==========

    // Generate date-wise revenue trend data
    const generateDateTrendData = useMemo(() => {
        // Handle invalid date ranges
        if (timeRange === 'custom') {
            const daysDiff = getDaysDifference(startDate, endDate);

            // Check if dates are valid
            if (daysDiff <= 0 || !startDate || !endDate) {
                // Return default empty data instead of crashing
                return [{
                    date: 'No data',
                    fullDate: new Date(),
                    revenue: 0,
                    netRevenue: 0,
                    discount: 0,
                    orders: 0
                }];
            }

            const data = [];
            const start = new Date(startDate);

            // Ensure we don't create too many data points
            const maxDays = Math.min(daysDiff, 365); // Max 1 year of data

            for (let i = 0; i < maxDays; i++) {
                const currentDate = new Date(start);
                currentDate.setDate(start.getDate() + i);
                const revenue = 15000 + Math.random() * 10000;
                const discount = Math.random() > 0.8 ? revenue * 0.1 : 0;
                data.push({
                    date: currentDate.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' }),
                    fullDate: currentDate,
                    revenue: Math.round(revenue),
                    netRevenue: Math.round(revenue - discount),
                    discount: Math.round(discount),
                    orders: Math.round(50 + Math.random() * 30)
                });
            }
            return data;
        }

        const getDays = () => {
            switch (timeRange) {
                case 'weekly': return 7;
                case 'monthly': return 30;
                case 'yearly': return 12;
                default: return 30;
            }
        };

        const days = getDays();
        const data = [];

        for (let i = days - 1; i >= 0; i--) {
            const date = new Date();

            if (timeRange === 'weekly') {
                date.setDate(date.getDate() - (i * 7));
                const revenue = 100000 + Math.random() * 50000;
                const discount = revenue * (0.05 + Math.random() * 0.05);
                data.push({
                    date: `Week ${i + 1}`,
                    fullDate: new Date(date),
                    revenue: Math.round(revenue),
                    netRevenue: Math.round(revenue - discount),
                    discount: Math.round(discount),
                    orders: Math.round(200 + Math.random() * 100)
                });
            } else if (timeRange === 'monthly') {
                const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                const monthIndex = (11 - i) % 12;
                const revenue = 350000 + Math.random() * 150000;
                const discount = revenue * (0.08 + Math.random() * 0.07);
                data.push({
                    date: months[monthIndex],
                    fullDate: new Date(date.getFullYear(), monthIndex, 1),
                    revenue: Math.round(revenue),
                    netRevenue: Math.round(revenue - discount),
                    discount: Math.round(discount),
                    orders: Math.round(1000 + Math.random() * 500)
                });
            } else { // yearly
                const years = ['2020', '2021', '2022', '2023', '2024'];
                if (i < years.length) {
                    const revenue = 4000000 + Math.random() * 2000000;
                    const discount = revenue * (0.1 + Math.random() * 0.05);
                    data.push({
                        date: years[i],
                        fullDate: new Date(years[i]),
                        revenue: Math.round(revenue),
                        netRevenue: Math.round(revenue - discount),
                        discount: Math.round(discount),
                        orders: Math.round(12000 + Math.random() * 5000)
                    });
                }
            }
        }
        return data;
    }, [timeRange, startDate, endDate]);

    // Generate expense trend data
    const generateExpenseTrendData = useMemo(() => {
        const dateData = generateDateTrendData;
        return dateData.map(item => {
            const expenses = {
                COGS: Math.round(item.revenue * (0.35 + Math.random() * 0.05)),
                Operating: Math.round(item.revenue * (0.20 + Math.random() * 0.03)),
                Labor: Math.round(item.revenue * (0.18 + Math.random() * 0.02)),
                Equipment: Math.round(item.revenue * (0.08 + Math.random() * 0.02)),
                Marketing: Math.round(item.revenue * (0.06 + Math.random() * 0.01)),
                Packaging: Math.round(item.revenue * (0.04 + Math.random() * 0.01)),
                Delivery: Math.round(item.revenue * (0.12 + Math.random() * 0.03)),
                Waste: Math.round(item.revenue * (0.03 + Math.random() * 0.01)),
                Tax: Math.round(item.revenue * (0.05 + Math.random() * 0.01)),
                Miscellaneous: Math.round(item.revenue * (0.02 + Math.random() * 0.01))
            };

            const totalExpenses = Object.values(expenses).reduce((a, b) => a + b, 0);
            const profit = item.netRevenue - totalExpenses;
            const profitMargin = (profit / item.revenue) * 100;
            const expenseRatio = (totalExpenses / item.revenue) * 100;

            return {
                date: item.date,
                fullDate: item.fullDate,
                revenue: item.revenue,
                netRevenue: item.netRevenue,
                totalExpenses,
                profit,
                profitMargin: parseFloat(profitMargin.toFixed(1)),
                expenseRatio: parseFloat(expenseRatio.toFixed(1)),
                ...expenses
            };
        });
    }, [generateDateTrendData]);

    // Calculate totals for each time range
    const calculateTimeRangeTotals = useMemo(() => {
        const ranges = ['yearly', 'monthly', 'weekly', 'custom'];
        const totals = {};

        ranges.forEach(range => {
            let data;
            if (range === 'custom') {
                const daysDiff = getDaysDifference(startDate, endDate);
                const tempData = [];
                const start = new Date(startDate);

                for (let i = 0; i < daysDiff; i++) {
                    const currentDate = new Date(start);
                    currentDate.setDate(start.getDate() + i);
                    const revenue = 15000 + Math.random() * 10000;
                    const discount = Math.random() > 0.8 ? revenue * 0.1 : 0;
                    tempData.push({
                        revenue: Math.round(revenue),
                        netRevenue: Math.round(revenue - discount),
                        discount: Math.round(discount),
                        orders: Math.round(50 + Math.random() * 30)
                    });
                }
                data = tempData;
            } else {
                const getDays = () => {
                    switch (range) {
                        case 'weekly': return 7;
                        case 'monthly': return 30;
                        case 'yearly': return 12;
                        default: return 30;
                    }
                };

                const days = getDays();
                const tempData = [];

                for (let i = days - 1; i >= 0; i--) {
                    if (range === 'weekly') {
                        const revenue = 100000 + Math.random() * 50000;
                        const discount = revenue * (0.05 + Math.random() * 0.05);
                        tempData.push({
                            revenue: Math.round(revenue),
                            netRevenue: Math.round(revenue - discount),
                            discount: Math.round(discount),
                            orders: Math.round(200 + Math.random() * 100)
                        });
                    } else if (range === 'monthly') {
                        const revenue = 350000 + Math.random() * 150000;
                        const discount = revenue * (0.08 + Math.random() * 0.07);
                        tempData.push({
                            revenue: Math.round(revenue),
                            netRevenue: Math.round(revenue - discount),
                            discount: Math.round(discount),
                            orders: Math.round(1000 + Math.random() * 500)
                        });
                    } else { // yearly
                        const revenue = 4000000 + Math.random() * 2000000;
                        const discount = revenue * (0.1 + Math.random() * 0.05);
                        tempData.push({
                            revenue: Math.round(revenue),
                            netRevenue: Math.round(revenue - discount),
                            discount: Math.round(discount),
                            orders: Math.round(12000 + Math.random() * 5000)
                        });
                    }
                }
                data = tempData;
            }

            // Calculate totals for this range
            const totalRevenue = data.reduce((sum, item) => sum + item.revenue, 0);
            const totalNetRevenue = data.reduce((sum, item) => sum + item.netRevenue, 0);
            const totalOrders = data.reduce((sum, item) => sum + item.orders, 0);

            // Calculate expenses
            const totalExpenses = Math.round(totalRevenue * 0.65); // Simplified expense calculation

            // For ratings (average based on orders)
            const totalReviews = Math.round(totalOrders * 0.3);
            const avgRating = 4.2 + Math.random() * 0.8;

            totals[range] = {
                revenue: totalRevenue,
                netRevenue: totalNetRevenue,
                expenses: totalExpenses,
                orders: totalOrders,
                profit: totalNetRevenue - totalExpenses,
                avgRating: parseFloat(avgRating.toFixed(1)),
                totalReviews: totalReviews
            };
        });

        return totals;
    }, [timeRange, startDate, endDate]);

    // Generate revenue by order type
    const generateOrderTypeData = useMemo(() => {
        const types = [
            { name: 'Dine-in', description: 'In-restaurant dining', color: '#7c3aed', icon: <Utensils size={16} /> },
            { name: 'Takeaway', description: 'Pickup orders', color: '#10b981', icon: <ShoppingBag size={16} /> },
            { name: 'Delivery', description: 'Home delivery', color: '#3b82f6', icon: <ShoppingCart size={16} /> },
            { name: 'Table', description: 'Event catering', color: '#f59e0b', icon: <Users size={16} /> }
        ];
        // Add check for empty array
        if (!generateDateTrendData.length) {
            return types.map(type => ({
                ...type,
                revenue: 0,
                percentage: 0,
                growth: 0
            }));
        }
        const totalRevenue = generateDateTrendData.reduce((sum, item) => sum + item.revenue, 0);
        return types.map(type => {
            const percentage = type.name === 'Delivery' ? 40 :
                type.name === 'Dine-in' ? 30 :
                    type.name === 'Takeaway' ? 15 : 5;
            const revenue = Math.round(totalRevenue * (percentage / 100));

            return {
                ...type,
                revenue,
                percentage,
                growth: (Math.random() > 0.5 ? 1 : -1) * (2 + Math.random() * 6)
            };
        });
    }, [generateDateTrendData]);

    // Generate revenue by category
    const generateCategoryData = useMemo(() => {
        const categories = [
            { name: 'Starters', description: 'Appetizers & snacks', color: '#f59e0b', icon: <Pizza size={16} /> },
            { name: 'Main Course', description: 'Main dishes & curries', color: '#10b981', icon: <Utensils size={16} /> },
            { name: 'Biryani', description: 'Rice dishes', color: '#ef4444', icon: <Pizza size={16} /> },
            { name: 'Fast Food', description: 'Burgers, pizzas, etc.', color: '#8b5cf6', icon: <ShoppingBag size={16} /> },
            { name: 'Desserts', description: 'Sweets & desserts', color: '#ec4899', icon: <Cake size={16} /> },
            { name: 'Beverages', description: 'Drinks & beverages', color: '#3b82f6', icon: <Coffee size={16} /> }
        ];

        // Add check for empty array
        if (!generateDateTrendData.length) {
            return categories.map(category => ({
                ...category,
                revenue: 0,
                percentage: 0,
                growth: 0
            }));
        }

        const totalRevenue = generateDateTrendData.reduce((sum, item) => sum + item.revenue, 0);
        return categories.map(category => {
            const percentage = category.name === 'Main Course' ? 35 :
                category.name === 'Biryani' ? 25 :
                    category.name === 'Starters' ? 15 :
                        category.name === 'Fast Food' ? 10 :
                            category.name === 'Beverages' ? 8 : 7;
            const revenue = Math.round(totalRevenue * (percentage / 100));

            return {
                ...category,
                revenue,
                percentage,
                growth: (Math.random() > 0.5 ? 1 : -1) * (3 + Math.random() * 8)
            };
        }).sort((a, b) => b.revenue - a.revenue);
    }, [generateDateTrendData]);

    // Generate top selling items
    const generateTopItemsData = useMemo(() => {
        const items = [
            { name: 'Chicken Biryani', category: 'Biryani', price: 320, cost: 180 },
            { name: 'Paneer Butter Masala', category: 'Main Course', price: 280, cost: 120 },
            { name: 'Veg Spring Rolls', category: 'Starters', price: 180, cost: 80 },
            { name: 'Chocolate Pastry', category: 'Desserts', price: 120, cost: 40 },
            { name: 'Cold Coffee', category: 'Beverages', price: 100, cost: 30 },
            { name: 'Veg Pizza', category: 'Fast Food', price: 200, cost: 100 },
            { name: 'Chicken Curry', category: 'Main Course', price: 300, cost: 140 },
            { name: 'Gulab Jamun', category: 'Desserts', price: 80, cost: 20 },
            { name: 'Mango Shake', category: 'Beverages', price: 110, cost: 35 },
            { name: 'French Fries', category: 'Fast Food', price: 130, cost: 50 }
        ];
        // Add check for empty array
        if (!generateDateTrendData.length) {
            return items.map(item => ({
                ...item,
                revenue: 0,
                orders: 0,
                profit: 0,
                profitMargin: 0,
                percentage: 0
            }));
        }


        const totalRevenue = generateDateTrendData.reduce((sum, item) => sum + item.revenue, 0);
        return items.map(item => {
            const percentage = 2 + Math.random() * 6;
            const revenue = Math.round(totalRevenue * (percentage / 100));
            const orders = Math.round(revenue / item.price);
            const profit = revenue - (orders * item.cost);
            const profitMargin = (profit / revenue) * 100;

            return {
                ...item,
                revenue,
                orders,
                profit,
                profitMargin: parseFloat(profitMargin.toFixed(1)),
                percentage: parseFloat(percentage.toFixed(1))
            };
        }).sort((a, b) => b.revenue - a.revenue);
    }, [generateDateTrendData]);

    // Generate payment data
    const generatePaymentData = useMemo(() => {
        const methods = [
            { name: 'Cash', description: 'Cash payments', color: '#10b981', icon: <DollarSign size={16} /> },
            { name: 'UPI', description: 'Digital payments', color: '#7c3aed', icon: <CreditCard size={16} /> },
            { name: 'Card', description: 'Credit/Debit cards', color: '#3b82f6', icon: <CreditCard size={16} /> },
            { name: 'Wallet', description: 'E-wallets', color: '#f59e0b', icon: <CreditCard size={16} /> },
            { name: 'Credit', description: 'Credit accounts', color: '#ef4444', icon: <CreditCard size={16} /> }
        ];
        // Add check for empty array
        if (!generateDateTrendData.length) {
            return methods.map(method => ({
                ...method,
                amount: 0,
                percentage: 0,
                transactions: 0
            }));
        }

        const totalRevenue = generateDateTrendData.reduce((sum, item) => sum + item.revenue, 0);
        return methods.map(method => {
            const percentage = method.name === 'UPI' ? 45 :
                method.name === 'Cash' ? 25 :
                    method.name === 'Card' ? 15 :
                        method.name === 'Wallet' ? 10 : 5;
            const amount = Math.round(totalRevenue * (percentage / 100));

            return {
                ...method,
                amount,
                percentage,
                transactions: Math.round(amount / (method.name === 'Cash' ? 500 : 800))
            };
        });
    }, [generateDateTrendData]);

    // Generate gross vs net revenue data
    const generateGrossNetData = useMemo(() => {
        return generateDateTrendData.map(item => ({
            date: item.date,
            gross: item.revenue,
            net: item.netRevenue,
            discount: item.discount,
            discountRate: parseFloat(((item.discount / item.revenue) * 100).toFixed(1))
        }));
    }, [generateDateTrendData]);

    // Generate discount impact data
    const generateDiscountImpactData = useMemo(() => {
        return generateDateTrendData.map((item, index) => ({
            date: item.date,
            ordersWithoutDiscount: Math.round(item.orders * 0.8),
            ordersWithDiscount: item.orders,
            discountOrders: Math.round(item.orders * 0.2),
            revenueWithoutDiscount: Math.round(item.revenue * 1.1),
            actualRevenue: item.revenue,
            discountAmount: item.discount,
            uplift: 25 + Math.random() * 15
        }));
    }, [generateDateTrendData]);

    // Generate expense data
    const generateExpenseData = useMemo(() => {
        const totalRevenue = generateDateTrendData.reduce((sum, item) => sum + item.revenue, 0);

        // Handle zero revenue case
        if (totalRevenue === 0) {
            return {
                expenses: [],
                summary: {
                    totalRevenue: 0,
                    totalExpenses: 0,
                    netProfit: 0,
                    profitMargin: 0,
                    expenseToRevenue: 0
                }
            };
        }

        const expenses = [
            {
                category: 'COGS',
                description: 'Cost of Goods Sold',
                details: 'Ingredients cost consumed',
                purpose: 'Controls food margin',
                color: '#ef4444',
                icon: <Calculator size={16} />,
                percentage: 35,
                amount: Math.round(totalRevenue * 0.35)
            },
            {
                category: 'Operating Expenses',
                description: 'Fixed operational costs',
                details: 'Rent, Electricity, Gas, Salaries, Licenses',
                purpose: 'Tracks unavoidable costs',
                color: '#f59e0b',
                icon: <Building size={16} />,
                percentage: 20,
                amount: Math.round(totalRevenue * 0.20)
            },
            {
                category: 'Labor Cost',
                description: 'Staff salaries & benefits',
                details: 'Payroll, overtime, incentives',
                purpose: 'Improves workforce planning',
                color: '#3b82f6',
                icon: <Users size={16} />,
                percentage: 18,
                amount: Math.round(totalRevenue * 0.18)
            },
            {
                category: 'Equipment Cost',
                description: 'Kitchen & maintenance',
                details: 'AMC, repairs, purchase',
                purpose: 'Maintenance efficiency',
                color: '#8b5cf6',
                icon: <Package size={16} />,
                percentage: 8,
                amount: Math.round(totalRevenue * 0.08)
            },
            {
                category: 'Marketing Expense',
                description: 'Promotions & advertising',
                details: 'Ads, offers, branding',
                purpose: 'Return on marketing investment',
                color: '#ec4899',
                icon: <Tag size={16} />,
                percentage: 6,
                amount: Math.round(totalRevenue * 0.06)
            },
            {
                category: 'Packaging Cost',
                description: 'Delivery materials',
                details: 'Delivery packaging & takeaway material',
                purpose: 'Impacts order profitability',
                color: '#10b981',
                icon: <ShoppingBag size={16} />,
                percentage: 4,
                amount: Math.round(totalRevenue * 0.04)
            },
            {
                category: 'Delivery Commission',
                description: 'Platform fees',
                details: 'Swiggy / Zomato / logistics fee',
                purpose: 'Influences pricing decisions',
                color: '#6366f1',
                icon: <Truck size={16} />,
                percentage: 12,
                amount: Math.round(totalRevenue * 0.12)
            },
            {
                category: 'Waste & Expiry',
                description: 'Inventory losses',
                details: 'Raw material wasted or expired',
                purpose: 'Identify negligence / control inventory',
                color: '#f97316',
                icon: <AlertCircle size={16} />,
                percentage: 3,
                amount: Math.round(totalRevenue * 0.03)
            },
            {
                category: 'Tax & Compliance',
                description: 'Government fees',
                details: 'GST filing, government fees',
                purpose: 'Financial discipline',
                color: '#14b8a6',
                icon: <FileText size={16} />,
                percentage: 5,
                amount: Math.round(totalRevenue * 0.05)
            },
            {
                category: 'Miscellaneous',
                description: 'Other expenses',
                details: 'Extra cost entries',
                purpose: 'Track unknown leakage',
                color: '#8b5cf6',
                icon: <Shield size={16} />,
                percentage: 2,
                amount: Math.round(totalRevenue * 0.02)
            }
        ];

        const totalExpenses = expenses.reduce((sum, expense) => sum + expense.amount, 0);
        const netProfit = totalRevenue - totalExpenses;
        const profitMargin = (netProfit / totalRevenue) * 100;

        return {
            expenses,
            summary: {
                totalRevenue,
                totalExpenses,
                netProfit,
                profitMargin: parseFloat(profitMargin.toFixed(1)),
                expenseToRevenue: parseFloat(((totalExpenses / totalRevenue) * 100).toFixed(1))
            }
        };
    }, [generateDateTrendData]);

    // ========== NEW DATA GENERATORS FOR ORDERS, PAYMENTS, RATINGS ==========

    // Generate orders analysis data
    // Generate orders analysis data - FIXED VERSION
    const generateOrdersData = useMemo(() => {
        const dateData = generateDateTrendData;

        // Handle empty array case
        if (!dateData.length) {
            return {
                trend: [],
                summary: {
                    totalOrders: 0,
                    avgDailyOrders: 0,
                    peakDay: { date: 'No data', orders: 0 },
                    avgOrderValue: 0
                },
                byTimeSlot: [],
                byDay: [],
                orderStatus: []
            };
        }

        const totalOrders = dateData.reduce((sum, item) => sum + (item.orders || 0), 0);

        // Safe average calculation
        const avgOrderValue = dateData.reduce((sum, item) => sum + (item.revenue || 0), 0) /
            dateData.reduce((sum, item) => sum + (item.orders || 1), 0);

        return {
            trend: dateData.map(item => ({
                date: item.date,
                orders: item.orders || 0,
                avgOrderValue: Math.round((item.revenue || 0) / (item.orders || 1)),
                peakHours: {
                    lunch: Math.round((item.orders || 0) * 0.4),
                    dinner: Math.round((item.orders || 0) * 0.5),
                    others: Math.round((item.orders || 0) * 0.1)
                }
            })),
            summary: {
                totalOrders,
                avgDailyOrders: Math.round(totalOrders / dateData.length),
                peakDay: dateData.reduce((prev, current) =>
                    (prev.orders || 0) > (current.orders || 0) ? prev : current
                ),
                avgOrderValue: Math.round(avgOrderValue)
            },
            byTimeSlot: [
                { time: '11AM-1PM', label: 'Dine-in', orders: Math.round(totalOrders * 0.35), color: '#f59e0b' },
                { time: '1PM-4PM', label: 'Takeaway', orders: Math.round(totalOrders * 0.15), color: '#3b82f6' },
                { time: '4PM-7PM', label: 'Delivery', orders: Math.round(totalOrders * 0.20), color: '#8b5cf6' },
                { time: '7PM-10PM', label: 'Table', orders: Math.round(totalOrders * 0.30), color: '#ef4444' }
            ],
            byDay: [
                { day: 'Monday', orders: Math.round(totalOrders * 0.14), growth: 5.2 },
                { day: 'Tuesday', orders: Math.round(totalOrders * 0.15), growth: 7.8 },
                { day: 'Wednesday', orders: Math.round(totalOrders * 0.16), growth: 3.4 },
                { day: 'Thursday', orders: Math.round(totalOrders * 0.17), growth: 9.1 },
                { day: 'Friday', orders: Math.round(totalOrders * 0.19), growth: 12.5 },
                { day: 'Saturday', orders: Math.round(totalOrders * 0.13), growth: -2.3 },
                { day: 'Sunday', orders: Math.round(totalOrders * 0.06), growth: -15.7 }
            ],
            orderStatus: [
                { status: 'Completed', count: Math.round(totalOrders * 0.85), color: '#10b981' },
                { status: 'Pending', count: Math.round(totalOrders * 0.08), color: '#f59e0b' },
                { status: 'Cancelled', count: Math.round(totalOrders * 0.05), color: '#ef4444' },
                { status: 'Refunded', count: Math.round(totalOrders * 0.02), color: '#64748b' }
            ]
        };
    }, [generateDateTrendData]);
    // Generate detailed payment mode data
    // Generate detailed payment mode data - FIXED VERSION
    const generatePaymentModeData = useMemo(() => {
        const dateData = generateDateTrendData;

        // Handle empty array case
        if (!dateData.length) {
            const methods = [
                { name: 'UPI', description: 'Digital payments', color: '#7c3aed', icon: <CreditCardIcon size={16} />, fee: 1.2 },
                { name: 'Cash', description: 'Cash payments', color: '#10b981', icon: <DollarSignIcon size={16} />, fee: 0 },
                { name: 'Card', description: 'Credit/Debit cards', color: '#3b82f6', icon: <CreditCard size={16} />, fee: 1.8 },
                { name: 'Wallet', description: 'E-wallets', color: '#f59e0b', icon: <Wallet size={16} />, fee: 1.0 },
                { name: 'Credit', description: 'Credit accounts', color: '#ef4444', icon: <CreditCard size={16} />, fee: 0 }
            ];

            return {
                trend: [],
                summary: methods.map(method => ({
                    ...method,
                    amount: 0,
                    percentage: 0,
                    transactions: 0,
                    processingFee: 0,
                    netAmount: 0
                })),
                feeAnalysis: {
                    totalFees: 0,
                    avgFeePercentage: 0,
                    mostCostly: 'None',
                    cheapest: 'None'
                }
            };
        }

        const totalRevenue = dateData.reduce((sum, item) => sum + (item.revenue || 0), 0);

        const methods = [
            { name: 'UPI', description: 'Digital payments', color: '#7c3aed', icon: <CreditCardIcon size={16} />, fee: 1.2 },
            { name: 'Cash', description: 'Cash payments', color: '#10b981', icon: <DollarSignIcon size={16} />, fee: 0 },
            { name: 'Card', description: 'Credit/Debit cards', color: '#3b82f6', icon: <CreditCard size={16} />, fee: 1.8 },
            { name: 'Wallet', description: 'E-wallets', color: '#f59e0b', icon: <Wallet size={16} />, fee: 1.0 },
            { name: 'Credit', description: 'Credit accounts', color: '#ef4444', icon: <CreditCard size={16} />, fee: 0 }
        ];

        return {
            trend: dateData.map(item => {
                const methodsData = {};
                methods.forEach(method => {
                    const percentage = method.name === 'UPI' ? 45 :
                        method.name === 'Cash' ? 25 :
                            method.name === 'Card' ? 15 :
                                method.name === 'Wallet' ? 10 : 5;
                    methodsData[method.name] = Math.round((item.revenue || 0) * (percentage / 100));
                });
                return {
                    date: item.date,
                    ...methodsData
                };
            }),
            summary: methods.map(method => {
                const percentage = method.name === 'UPI' ? 45 :
                    method.name === 'Cash' ? 25 :
                        method.name === 'Card' ? 15 :
                            method.name === 'Wallet' ? 10 : 5;
                const amount = Math.round(totalRevenue * (percentage / 100));
                const transactions = Math.round(amount / (method.name === 'Cash' ? 500 : 800));
                const processingFee = Math.round(amount * (method.fee / 100));

                return {
                    ...method,
                    amount,
                    percentage,
                    transactions,
                    processingFee,
                    netAmount: amount - processingFee
                };
            }),
            feeAnalysis: {
                totalFees: Math.round(totalRevenue * 0.012),
                avgFeePercentage: 1.2,
                mostCostly: 'Card',
                cheapest: 'Cash'
            }
        };
    }, [generateDateTrendData]);

    // Generate ratings and feedback data
    // Generate ratings and feedback data - FIXED VERSION
    const generateRatingsData = useMemo(() => {
        const dateData = generateDateTrendData;

        // Handle empty array case
        if (!dateData.length) {
            return {
                trend: [],
                summary: {
                    overallRating: 0,
                    totalReviews: 0,
                    responseRate: 0,
                    avgResponseTime: '0 hours'
                },
                distribution: [],
                feedbackCategories: [],
                commonIssues: []
            };
        }

        const totalOrders = dateData.reduce((sum, item) => sum + (item.orders || 0), 0);

        return {
            trend: dateData.map(item => ({
                date: item.date,
                avgRating: 4.2 + Math.random() * 0.8,
                totalReviews: Math.round((item.orders || 0) * 0.3),
                positiveReviews: Math.round((item.orders || 0) * 0.25),
                negativeReviews: Math.round((item.orders || 0) * 0.05)
            })),
            summary: {
                overallRating: 4.5,
                totalReviews: Math.round(totalOrders * 0.3),
                responseRate: 85,
                avgResponseTime: '2.4 hours'
            },
            distribution: [
                { rating: 5, count: Math.round(totalOrders * 0.15), color: '#10b981', label: 'Excellent' },
                { rating: 4, count: Math.round(totalOrders * 0.10), color: '#3b82f6', label: 'Good' },
                { rating: 3, count: Math.round(totalOrders * 0.03), color: '#f59e0b', label: 'Average' },
                { rating: 2, count: Math.round(totalOrders * 0.01), color: '#ef4444', label: 'Poor' },
                { rating: 1, count: Math.round(totalOrders * 0.01), color: '#dc2626', label: 'Terrible' }
            ],
            feedbackCategories: [
                { category: 'Food Quality', rating: 4.7, reviews: 125, color: '#10b981' },
                { category: 'Delivery Time', rating: 4.2, reviews: 98, color: '#3b82f6' },
                { category: 'Packaging', rating: 4.5, reviews: 87, color: '#f59e0b' },
                { category: 'Customer Service', rating: 4.3, reviews: 76, color: '#8b5cf6' },
                { category: 'Value for Money', rating: 4.4, reviews: 92, color: '#ec4899' }
            ],
            commonIssues: [
                { issue: 'Late Delivery', count: 23, percentage: 12 },
                { issue: 'Wrong Order', count: 15, percentage: 8 },
                { issue: 'Food Temperature', count: 12, percentage: 6 },
                { issue: 'Packaging Damaged', count: 8, percentage: 4 },
                { issue: 'Payment Issues', count: 5, percentage: 3 }
            ]
        };
    }, [generateDateTrendData]);


    const TimeRangeTotalsDisplay = () => {
        // ✅ Get totals from state (fetched from APIs)
        const totals = customTotals || {};

        const formatCurrency = (num) => {
            if (typeof num !== 'number' || isNaN(num)) {
                return `₹0`;
            }
            return `₹${num.toLocaleString("en-IN")}`;
        };

        const metrics = [
            {
                label: "Revenue",
                value: formatCurrency(totals.revenue || 0),
                icon: <span style={{ fontSize: "18px", fontWeight: "700" }}>₹</span>,
                color: "#10b981",
                bgColor: "#dcfce7",
                description: "All-time Total Revenue"
            },
            {
                label: "Orders",
                value: totals.orders
                    ? totals.orders.toLocaleString("en-IN")
                    : "0",
                icon: <ShoppingBag size={10} />,
                color: "#f59e0b",
                bgColor: "#fef3c7",
                description: "All-time Total Orders"
            },
            {
                label: "Rating",
                value: `${Number(totals.avgRating || 0).toFixed(1)}/5`,
                icon: <StarIcon size={10} />,
                color: "#3b82f6",
                bgColor: "#dbeafe",
                description: startDate && endDate
                    ? `Rating for ${formatDate(startDate)} to ${formatDate(endDate)}`
                    : "All-time Average Rating"
            },
        ];

        const metricCount = metrics.length;

        return (
            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: isMobile
                        ? (metricCount <= 2 ? "repeat(2, 1fr)" : "repeat(2, 1fr)")
                        : (metricCount <= 3 ? `repeat(${metricCount}, minmax(0, 200px))` : "repeat(4, 1fr)"),
                    gap: isMobile ? "6px" : "8px",
                    marginTop: "-15px",
                    padding: "8px",
                    justifyContent: "center",
                    justifyItems: "center",
                }}
            >
                {metrics.map((metric, index) => (
                    <div
                        key={index}
                        style={{
                            textAlign: "center",
                            padding: "8px 6px",
                            background: metric.bgColor,
                            borderRadius: "8px",
                            border: `1px solid ${metric.color}20`,
                            minHeight: "60px",
                            width: isMobile ? "100%" : "180px",
                            maxWidth: "250px",
                            position: "relative",
                            cursor: "help",
                        }}
                        title={metric.description} // Tooltip on hover
                    >
                        <div
                            style={{
                                fontSize: isMobile ? "8px" : "9px",
                                color: metric.color,
                                fontWeight: "600",
                                marginBottom: "3px",
                                textTransform: "uppercase",
                                letterSpacing: "0.3px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "3px",
                            }}
                        >
                            {metric.icon}
                            {metric.label}
                        </div>

                        <div
                            style={{
                                fontSize: isMobile ? "14px" : "16px",
                                fontWeight: "800",
                                color: "#1e293b",
                                marginBottom: "3px",
                                lineHeight: "1.2",
                            }}
                        >
                            {metric.value}
                        </div>

                        <div
                            style={{
                                fontSize: isMobile ? "7px" : "8px",
                                color: metric.color,
                                opacity: 0.7,
                            }}
                        >
                            {metric.label === "Rating" && startDate && endDate
                                ? "Custom Range"
                                : metric.label === "Rating"
                                    ? "All Time"
                                    : "All Time"}
                        </div>
                    </div>
                ))}
            </div>
        );
    };


    // View Toggles
    const ViewToggles = () => (
        <div style={{
            marginTop: '6px',
            display: 'flex',
            gap: isMobile ? '4px' : '8px',
            background: 'transparent',
            padding: isMobile ? '3px' : '4px',
            borderRadius: '12px',
            justifyContent: isMobile ? 'space-around' : 'center',
            overflowX: isMobile ? 'auto' : 'visible',
            flexWrap: 'wrap'
        }}>
            {[
                { key: 'revenueExpenses', label: 'Financials', icon: <Scale size={16} />, color: '#3b82f6' },
                { key: 'revenue', label: 'Revenue', icon: <DollarSign size={16} />, color: '#10b981' },
                // { key: 'expenses', label: 'Expenses', icon: <Calculator size={16} />, color: '#ef4444' },
                { key: 'orders', label: 'Orders', icon: <ShoppingBag size={16} />, color: '#f59e0b' },
                { key: 'payments', label: 'Payments', icon: <CreditCardIcon size={16} />, color: '#7c3aed' },
                { key: 'ratings', label: 'Ratings', icon: <StarIcon size={16} />, color: '#8b5cf6' }
            ].map(view => (
                <button
                    key={view.key}
                    onClick={() => setActiveView(view.key)}
                    style={{
                        padding: isMobile ? '10px 12px' : '10px 16px',
                        background: activeView === view.key ?
                            `linear-gradient(135deg, ${view.color} 0%, ${view.color}80 100%)` :
                            'white',
                        color: activeView === view.key ? 'white' : view.color,
                        border: `2px solid ${activeView === view.key ? view.color : view.color}20`,
                        borderRadius: '12px',
                        fontSize: isMobile ? '12px' : '14px',
                        fontWeight: activeView === view.key ? '700' : '600',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                        flexShrink: 0,
                        boxShadow: activeView === view.key ?
                            `0 4px 12px ${view.color}40` :
                            '0 2px 8px rgba(0,0,0,0.05)',
                        minWidth: isMobile ? '90px' : '110px',
                        justifyContent: 'center',
                        height: '44px',
                        transition: 'all 0.2s ease',
                        marginBottom: isMobile ? '3px' : '0',
                        whiteSpace: 'nowrap'
                    }}
                    onMouseEnter={(e) => {
                        if (activeView !== view.key) {
                            e.currentTarget.style.background = `${view.color}10`;
                            e.currentTarget.style.borderColor = view.color;
                        }
                    }}
                    onMouseLeave={(e) => {
                        if (activeView !== view.key) {
                            e.currentTarget.style.background = 'white';
                            e.currentTarget.style.borderColor = `${view.color}20`;
                        }
                    }}
                >
                    {view.icon}
                    {view.label}
                </button>
            ))}
        </div>
    );

    // ========== MAIN RENDER ==========

    if (loading) {
        return (
            <div style={{
                height: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
            }}>
                <div style={{
                    width: '60px',
                    height: '60px',
                    border: '4px solid rgba(255, 255, 255, 0.3)',
                    borderTopColor: 'white',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                }}></div>
            </div>
        );
    };

    return (
        <div style={{
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
            overflow: 'hidden'
        }}>
            {/* Header */}
            <div style={{
                background: 'white',
                padding: isMobile ? '16px 20px' : '20px 28px',
                top: '-20px',
                zIndex: 100,
                marginTop: '-20px',
                flexShrink: 0
            }} className="main-sticky-scroll-mobile">
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '16px'
                }}>


                    {isMobile && (
                        <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                            <button
                                onClick={() => setShowMobileMenu(!showMobileMenu)}
                                style={{
                                    width: '44px',
                                    height: '44px',
                                    background: colors.gradient,
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '12px',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    boxShadow: '0 4px 12px rgba(124, 58, 237, 0.3)'
                                }}
                            >
                                <Menu size={22} />
                            </button>
                        </div>
                    )}
                </div>

                {/* Time Range + Export/Reset */}
                <div style={{
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    gap: isMobile ? '12px' : '16px',
                    alignItems: 'center',
                    top: '-21px',
                    justifyContent: 'space-between',
                    position: 'relative'
                }}>
                    {/* Time Range Selector */}
                    <div style={{
                        display: 'flex',
                        gap: isMobile ? '6px' : '15px',
                        background: 'transparent',
                        padding: isMobile ? '4px' : '6px',
                        borderRadius: '16px',
                        width: isMobile ? '100%' : 'auto',
                        flexWrap: 'wrap',
                        position: 'relative'
                    }}>
                        {[
                            // { key: 'yearly', label: isMobile ? 'Year' : 'Yearly', icon: <CalendarIcon size={16} />, color: '#7c3aed' },
                            // { key: 'monthly', label: isMobile ? 'Month' : 'Monthly', icon: <CalendarIcon size={16} />, color: '#10b981' },
                            // { key: 'weekly', label: isMobile ? 'Week' : 'Weekly', icon: <CalendarIcon size={16} />, color: '#3b82f6' },
                            { key: 'custom', label: isMobile ? 'Custom' : 'Custom Range', icon: <CalendarIcon size={16} />, color: '#ef4444' }
                        ].map(range => (
                            <div key={range.key} style={{ position: 'relative' }}>
                                <button
                                    onClick={() => {
                                        if (range.key === 'custom') {
                                            setTimeRange('custom');
                                            setShowDatePicker(!showDatePicker);
                                            setTimeFilter(null);
                                        } else {
                                            // Set timeRange immediately when button is clicked
                                            setTimeRange(range.key);
                                            // Show filter dropdown
                                            setTimeFilter(timeFilter === range.key ? null : range.key);
                                            setShowDatePicker(false);
                                        }
                                    }}
                                    style={{
                                        padding: isMobile ? '8px 12px' : '10px 10px',
                                        background: timeRange === range.key ?
                                            `linear-gradient(135deg, ${range.color} 0%, ${range.color}80 100%)` :
                                            'white',
                                        color: timeRange === range.key ? 'white' : range.color,
                                        border: `2px solid ${timeRange === range.key ? range.color : range.color}20`,
                                        borderRadius: '12px',
                                        fontSize: isMobile ? '12px' : '14px',
                                        fontWeight: timeRange === range.key ? '700' : '600',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '6px',
                                        whiteSpace: 'nowrap',
                                        flex: isMobile ? '1' : 'none',
                                        position: 'relative',
                                        zIndex: 1,
                                        transition: 'all 0.3s ease',
                                        boxShadow: timeRange === range.key ?
                                            `0 4px 12px ${range.color}40` :
                                            '0 2px 8px rgba(0,0,0,0.05)',
                                        minWidth: isMobile ? '80px' : '100px',
                                        justifyContent: 'center'
                                    }}
                                    onMouseEnter={(e) => {
                                        if (timeRange !== range.key) {
                                            e.currentTarget.style.background = `${range.color}10`;
                                            e.currentTarget.style.borderColor = range.color;
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        if (timeRange !== range.key) {
                                            e.currentTarget.style.background = 'white';
                                            e.currentTarget.style.borderColor = `${range.color}20`;
                                        }
                                    }}
                                >
                                    {range.icon}
                                    {range.label}
                                </button>

                                {/* Individual Filter Popup for each button */}
                                {timeFilter === range.key && (
                                    <div style={{
                                        position: 'absolute',
                                        top: 'calc(100% + 10px)',
                                        left: '0',
                                        background: 'white',
                                        borderRadius: '16px',
                                        border: '1px solid #e2e8f0',
                                        boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
                                        zIndex: 1001,
                                        minWidth: '200px',
                                        maxWidth: '280px',
                                        maxHeight: '350px',
                                        overflowY: 'auto',
                                        animation: 'slideDown 0.2s ease'
                                    }}>
                                        <div style={{
                                            padding: '16px',
                                            borderBottom: '1px solid #e2e8f0',
                                            background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)'
                                        }}>
                                            <h4 style={{
                                                fontSize: '14px',
                                                fontWeight: '700',
                                                color: '#1e293b',
                                                marginBottom: '12px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px'
                                            }}>
                                                {range.key === 'yearly' ? <CalendarIcon size={16} /> :
                                                    range.key === 'monthly' ? <CalendarIcon size={16} /> :
                                                        <CalendarIcon size={16} />}
                                                Select {range.key}
                                            </h4>

                                            {range.key === 'yearly' && (
                                                <div style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    gap: '8px'
                                                }}>
                                                    {['2024', '2023', '2022', '2021', '2020'].map(year => (
                                                        <button
                                                            key={year}
                                                            onClick={() => {
                                                                selectYear(year);
                                                                setTimeRange('yearly');
                                                                setTimeFilter(null);
                                                            }}
                                                            style={{
                                                                padding: '12px 16px',
                                                                background: selectedYear === year ?
                                                                    'linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%)' :
                                                                    'white',
                                                                color: selectedYear === year ? 'white' : '#475569',
                                                                border: selectedYear === year ? 'none' : '1px solid #e2e8f0',
                                                                borderRadius: '10px',
                                                                fontSize: '14px',
                                                                textAlign: 'left',
                                                                cursor: 'pointer',
                                                                transition: 'all 0.2s',
                                                                fontWeight: selectedYear === year ? '600' : '400',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'space-between'
                                                            }}
                                                            onMouseEnter={(e) => {
                                                                if (selectedYear !== year) {
                                                                    e.currentTarget.style.background = '#f8fafc';
                                                                    e.currentTarget.style.borderColor = '#7c3aed';
                                                                    e.currentTarget.style.color = '#7c3aed';
                                                                }
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                if (selectedYear !== year) {
                                                                    e.currentTarget.style.background = 'white';
                                                                    e.currentTarget.style.borderColor = '#e2e8f0';
                                                                    e.currentTarget.style.color = '#475569';
                                                                }
                                                            }}
                                                        >
                                                            {year}
                                                            {selectedYear === year && (
                                                                <CheckCircle size={16} color="white" />
                                                            )}
                                                        </button>
                                                    ))}
                                                </div>
                                            )}

                                            {range.key === 'monthly' && (
                                                <div style={{
                                                    display: 'grid',
                                                    gridTemplateColumns: 'repeat(3, 1fr)',
                                                    gap: '8px'
                                                }}>
                                                    {[
                                                        { value: '01', label: 'Jan' }, { value: '02', label: 'Feb' }, { value: '03', label: 'Mar' },
                                                        { value: '04', label: 'Apr' }, { value: '05', label: 'May' }, { value: '06', label: 'Jun' },
                                                        { value: '07', label: 'Jul' }, { value: '08', label: 'Aug' }, { value: '09', label: 'Sep' },
                                                        { value: '10', label: 'Oct' }, { value: '11', label: 'Nov' }, { value: '12', label: 'Dec' }
                                                    ].map(month => (
                                                        <button
                                                            key={month.value}
                                                            onClick={() => {
                                                                selectMonth(month.value);
                                                                setTimeRange('monthly');
                                                                setTimeFilter(null);
                                                            }}
                                                            style={{
                                                                padding: '12px 8px',
                                                                background: selectedMonth === month.value ?
                                                                    'linear-gradient(135deg, #10b981 0%, #059669 100%)' :
                                                                    'white',
                                                                color: selectedMonth === month.value ? 'white' : '#475569',
                                                                border: selectedMonth === month.value ? 'none' : '1px solid #e2e8f0',
                                                                borderRadius: '10px',
                                                                fontSize: '13px',
                                                                cursor: 'pointer',
                                                                transition: 'all 0.2s',
                                                                fontWeight: selectedMonth === month.value ? '600' : '400',
                                                                display: 'flex',
                                                                justifyContent: 'center',
                                                                alignItems: 'center',
                                                                flexDirection: 'column',
                                                                gap: '4px'
                                                            }}
                                                            onMouseEnter={(e) => {
                                                                if (selectedMonth !== month.value) {
                                                                    e.currentTarget.style.background = '#f8fafc';
                                                                    e.currentTarget.style.borderColor = '#10b981';
                                                                    e.currentTarget.style.color = '#10b981';
                                                                }
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                if (selectedMonth !== month.value) {
                                                                    e.currentTarget.style.background = 'white';
                                                                    e.currentTarget.style.borderColor = '#e2e8f0';
                                                                    e.currentTarget.style.color = '#475569';
                                                                }
                                                            }}
                                                        >
                                                            {month.label}
                                                            {selectedMonth === month.value && (
                                                                <div style={{
                                                                    width: '6px',
                                                                    height: '6px',
                                                                    borderRadius: '50%',
                                                                    background: 'white'
                                                                }}></div>
                                                            )}
                                                        </button>
                                                    ))}
                                                </div>
                                            )}

                                            {range.key === 'weekly' && (
                                                <div style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    gap: '8px'
                                                }}>
                                                    {['This Week', 'Last Week', 'Week 1', 'Week 2', 'Week 3', 'Week 4'].map(week => (
                                                        <button
                                                            key={week}
                                                            onClick={() => {
                                                                selectWeek(week);
                                                                setTimeRange('weekly');
                                                                setTimeFilter(null);
                                                            }}
                                                            style={{
                                                                padding: '12px 16px',
                                                                background: selectedWeek === week ?
                                                                    'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)' :
                                                                    'white',
                                                                color: selectedWeek === week ? 'white' : '#475569',
                                                                border: selectedWeek === week ? 'none' : '1px solid #e2e8f0',
                                                                borderRadius: '10px',
                                                                fontSize: '14px',
                                                                textAlign: 'left',
                                                                cursor: 'pointer',
                                                                transition: 'all 0.2s',
                                                                fontWeight: selectedWeek === week ? '600' : '400',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'space-between'
                                                            }}
                                                            onMouseEnter={(e) => {
                                                                if (selectedWeek !== week) {
                                                                    e.currentTarget.style.background = '#f8fafc';
                                                                    e.currentTarget.style.borderColor = '#3b82f6';
                                                                    e.currentTarget.style.color = '#3b82f6';
                                                                }
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                if (selectedWeek !== week) {
                                                                    e.currentTarget.style.background = 'white';
                                                                    e.currentTarget.style.borderColor = '#e2e8f0';
                                                                    e.currentTarget.style.color = '#475569';
                                                                }
                                                            }}
                                                        >
                                                            {week}
                                                            {selectedWeek === week && (
                                                                <CheckCircle size={16} color="white" />
                                                            )}
                                                        </button>
                                                    ))}
                                                </div>
                                            )}
                                        </div>

                                        <div style={{
                                            padding: '12px 16px',
                                            background: '#f8fafc',
                                            borderTop: '1px solid #e2e8f0',
                                            borderBottomLeftRadius: '16px',
                                            borderBottomRightRadius: '16px'
                                        }}>
                                            <button
                                                onClick={() => setTimeFilter(null)}
                                                style={{
                                                    width: '100%',
                                                    padding: '10px',
                                                    background: 'white',
                                                    color: '#64748b',
                                                    border: '1px solid #e2e8f0',
                                                    borderRadius: '8px',
                                                    fontSize: '13px',
                                                    fontWeight: '500',
                                                    cursor: 'pointer',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    gap: '8px',
                                                    transition: 'all 0.2s'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.background = '#f1f5f9';
                                                    e.currentTarget.style.color = '#475569';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.background = 'white';
                                                    e.currentTarget.style.color = '#64748b';
                                                }}
                                            >
                                                <X size={14} />
                                                Close
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>

                    {/* Add click outside handler for popups */}
                    {timeFilter && (
                        <div
                            onClick={() => setTimeFilter(null)}
                            style={{
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                zIndex: 1000,
                                // No background, just for click detection
                            }}
                        />
                    )}

                    {/* Date Picker Modal with Today Button */}
                    {showDatePicker && (
                        <div style={{
                            position: 'absolute',
                            top: 'calc(100% + 3px)',
                            left: isMobile ? '16px' : '270px',
                            right: isMobile ? '16px' : 'calc(100% - 320px)',
                            background: 'white',
                            padding: '12px',
                            borderRadius: '12px',
                            border: '1px solid #e2e8f0',
                            boxShadow: '0 6px 24px rgba(0,0,0,0.1)',
                            zIndex: 1001,
                            width: isMobile ? 'calc(100% - 32px)' : '280px'
                        }}>
                            <div style={{
                                display: 'flex',
                                gap: '8px',
                                alignItems: 'center',
                                marginBottom: '12px',
                                flexWrap: 'nowrap'
                            }}>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <input
                                        type="date"
                                        value={startDate}
                                        max={endDate || new Date().toISOString().split("T")[0]} // Prevent selecting after end date or today
                                        onChange={(e) => setStartDate(e.target.value)}
                                        style={{
                                            width: '100%',
                                            padding: '6px 8px',
                                            border: '1px solid #e2e8f0',
                                            borderRadius: '6px',
                                            fontSize: '12px',
                                            outline: 'none',
                                            boxSizing: 'border-box'
                                        }}
                                    />
                                </div>
                                <span style={{
                                    color: '#94a3b8',
                                    fontSize: '11px',
                                    flexShrink: 0,
                                    minWidth: '20px',
                                    textAlign: 'center'
                                }}>
                                    to
                                </span>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <input
                                        type="date"
                                        value={endDate}
                                        max={new Date().toISOString().split("T")[0]} // Cannot select future dates
                                        min={startDate} // Cannot select before start date
                                        onChange={(e) => setEndDate(e.target.value)}
                                        style={{
                                            width: '100%',
                                            padding: '6px 8px',
                                            border: '1px solid #e2e8f0',
                                            borderRadius: '6px',
                                            fontSize: '12px',
                                            outline: 'none',
                                            boxSizing: 'border-box'
                                        }}
                                    />
                                </div>
                            </div>

                            <div style={{
                                display: 'flex',
                                gap: '8px',
                                marginBottom: '12px',
                                flexWrap: 'wrap'
                            }}>
                                <button
                                    onClick={() => {
                                        const today = new Date();
                                        const todayStr = today.toISOString().split('T')[0];
                                        setStartDate(todayStr);
                                        setEndDate(todayStr);
                                    }}
                                    style={{
                                        flex: '1 1 100px',
                                        padding: '6px 8px',
                                        background: '#f1f5f9',
                                        color: '#3b82f6',
                                        border: '1px solid #e2e8f0',
                                        borderRadius: '6px',
                                        fontSize: '12px',
                                        fontWeight: '500',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '4px',
                                        minWidth: 0
                                    }}
                                >
                                    <Clock size={12} />
                                    Today
                                </button>

                                {startDate && endDate && (
                                    <div style={{
                                        flex: '1 1 100px',
                                        padding: '6px 8px',
                                        background: '#f8fafc',
                                        borderRadius: '6px',
                                        fontSize: '11px',
                                        color: '#64748b',
                                        textAlign: 'center',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        minWidth: 0
                                    }}>
                                        {getDaysDifference(startDate, endDate)} days
                                    </div>
                                )}
                            </div>

                            <div style={{
                                display: 'flex',
                                gap: '8px'
                            }}>
                                <button
                                    onClick={() => {
                                        handleDateRangeApply();
                                        setShowDatePicker(false);
                                    }}
                                    disabled={!startDate || !endDate}
                                    style={{
                                        flex: 1,
                                        padding: '6px',
                                        background: colors.primary,
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '6px',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        cursor: (!startDate || !endDate) ? 'not-allowed' : 'pointer',
                                        opacity: (!startDate || !endDate) ? 0.5 : 1,
                                        minWidth: 0
                                    }}
                                >
                                    Apply
                                </button>
                                <button
                                    onClick={() => {
                                        handleDateRangeCancel();
                                        setShowDatePicker(false);
                                    }}
                                    style={{
                                        flex: 1,
                                        padding: '6px',
                                        background: 'transparent',
                                        color: '#64748b',
                                        border: '1px solid #e2e8f0',
                                        borderRadius: '6px',
                                        fontSize: '12px',
                                        fontWeight: '500',
                                        cursor: 'pointer',
                                        minWidth: 0
                                    }}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    )}

                    {/* Export and Reset Buttons */}
                    <div style={{ display: 'flex', gap: '8px', width: isMobile ? '100%' : 'auto' }}>
                        <button
                            onClick={handleReset}
                            disabled={resetting}
                            style={{
                                padding: isMobile ? '10px 16px' : '12px 20px',
                                background: resetting ? '#94a3b8' : '#f59e0b',
                                color: 'white',
                                border: 'none',
                                borderRadius: '12px',
                                fontSize: isMobile ? '13px' : '14px',
                                fontWeight: '600',
                                cursor: resetting ? 'not-allowed' : 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                flex: isMobile ? 1 : 'none',
                                justifyContent: 'center'
                            }}
                        >
                            <RotateCcw size={isMobile ? 16 : 18} className={resetting ? 'spin' : ''} />
                            {resetting ? '...' : 'Reset'}
                        </button>
                        <button
                            onClick={() => {
                                // Export functionality
                                const exportData = generateDateTrendData;
                                const ws = XLSX.utils.json_to_sheet(exportData);
                                const wb = XLSX.utils.book_new();
                                XLSX.utils.book_append_sheet(wb, ws, "Report");
                                XLSX.writeFile(wb, `Analytics_${timeRange}_${new Date().toISOString().split('T')[0]}.xlsx`);
                            }}
                            style={{
                                padding: isMobile ? '10px 16px' : '12px 20px',
                                background: colors.gradient,
                                color: 'white',
                                border: 'none',
                                borderRadius: '12px',
                                fontSize: isMobile ? '13px' : '14px',
                                fontWeight: '600',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                flex: isMobile ? 1 : 'none',
                                justifyContent: 'center'
                            }}
                        >
                            <Download size={isMobile ? 16 : 18} />
                            Export
                        </button>
                    </div>
                </div>

                {/* Time Range Totals Display - Shows totals for selected time range */}
                <TimeRangeTotalsDisplay />

                {/* View Toggles */}
                <ViewToggles />
            </div>

            {/* Content Area */}
            <div style={{
                flex: 1,
                overflowY: 'auto',
                overflowX: 'hidden',
                marginBottom: '70px',
                padding: isMobile ? '20px' : '28px',
                position: 'relative',
                WebkitOverflowScrolling: 'touch'
            }}>
                {/* Render content based on active view */}
                {activeView === 'revenueExpenses' && (
                    <Financials
                        isMobile={isMobile}
                        colors={colors}
                        generateDateTrendData={generateDateTrendData}
                        generateExpenseTrendData={generateExpenseTrendData}
                        startDate={startDate}     // ✅ ADD THIS
                        endDate={endDate}         // ✅ ADD THIS
                    />
                )}


                {activeView === 'revenue' && (
                    <Revenue
                        isMobile={isMobile}
                        colors={colors}
                        generateDateTrendData={generateDateTrendData}
                        generateOrderTypeData={generateOrderTypeData}
                        generateCategoryData={generateCategoryData}
                        generateTopItemsData={generateTopItemsData}
                        generatePaymentData={generatePaymentData}
                        generateGrossNetData={generateGrossNetData}
                        generateDiscountImpactData={generateDiscountImpactData}
                        startDate={startDate}     // ✅ ADD THIS
                        endDate={endDate}         // ✅ ADD THIS
                    />
                )}

                {/* {activeView === 'expenses' && (
                    <Expenses
                        isMobile={isMobile}
                        colors={colors}
                        generateExpenseTrendData={generateExpenseTrendData}
                        generateExpenseData={generateExpenseData}
                    />
                )} */}

                {activeView === 'orders' && (
                    <Orders
                        isMobile={isMobile}
                        // Pass the filter state
                        timeRange={timeRange}
                        startDate={startDate}
                        endDate={endDate}
                    // Remove mock data if not needed
                    // generateOrdersData={generateOrdersData}
                    />
                )}

                {activeView === 'payments' && (
                    <Payments
                        isMobile={isMobile}
                        colors={colors}
                        generatePaymentModeData={generatePaymentModeData}
                    />
                )}

                {activeView === 'ratings' && (
                    <Ratings
                        isMobile={isMobile}
                        colors={colors}
                        generateRatingsData={generateRatingsData}
                    />
                )}

                {/* Bottom padding */}
                <div style={{ height: isMobile ? '100px' : '60px' }}></div>
            </div>

            <style>{`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
                .spin {
                    animation: spin 1s linear infinite;
                }
                ::-webkit-scrollbar { display: none; }
            `}</style>
        </div>
    );
};

export default StandardReport;